const nl = {
  app: {
    name: 'Fit En Sterker',
  },
  auth: {
    coachPortalTitle: 'Coach Portal — inloggen',
    clientPortalTitle: 'Cliënt Portal — inloggen',
    email: 'E-mailadres',
    emailPlaceholder: 'naam@voorbeeld.nl',
    password: 'Wachtwoord',
    loading: 'Bezig...',
    startTraag: 'Verbinden met de server duurt langer dan gebruikelijk — dit kan gebeuren bij de eerste keer laden na een tijdje niet gebruikt te zijn. Even geduld, dit duurt meestal maximaal een paar minuten.',
    login: 'Inloggen',
    loginFooter: 'Gebruik hetzelfde account als in de Fit En Sterker app.',
    errorInvalidCredentials: 'Onjuist e-mailadres of wachtwoord.',
    errorGeneric: 'Inloggen mislukt. Probeer het opnieuw.',
    forgotPasswordQ: 'Wachtwoord vergeten?',
    forgotPasswordTitle: 'Wachtwoord vergeten',
    forgotPasswordSub: 'Vul je e-mailadres in. Je ontvangt een link om een nieuw wachtwoord in te stellen.',
    sendReset: 'Verstuur resetlink',
    backToLogin: 'Terug naar inloggen',
    resetEmailSent: 'Als dit e-mailadres bekend is, is er een resetlink verstuurd. Controleer je inbox.',
    errorResetGeneric: 'Aanvragen van de resetlink is mislukt. Probeer het opnieuw.',
  },
  nav: {
    coachPortal: 'Coach Portal',
    clientPortal: 'Cliënt Portal',
    rooster: 'Rooster',
    clients: 'Cliënten',
    facturering: 'Facturering',
    opzeggingen: 'Opzeggingen',
    mijnFacturen: 'Mijn Facturen',
    mijnCredits: 'Mijn Credits',
    mijnLessen: 'Mijn lessen',
    voeding: 'Voeding',
    mijnAbonnement: 'Mijn abonnement',
    mijnAfspraken: 'PT-afspraken',
    instellingen: 'Instellingen',
    uitloggen: 'Uitloggen',
    credits: 'credits',
    creditsResterend: 'credits resterend',
    klantnummer: 'Klantnr.',
    mijnGegevens: 'Mijn gegevens',
    recepten: 'Recepten',
    pushNotificaties: 'Push notificaties',
    ptAanvragen: 'PT-aanvragen',
    acties: 'Openstaande acties',
    cronDashboard: 'Cron-dashboard',
    gebruikersBeheer: 'Gebruikersbeheer',
    menuOpenen: 'Menu openen',
    roles: {
      superadmin: 'Superadmin',
      admin_coach: 'Admin Coach',
      coach: 'Coach',
      client: 'Cliënt',
    },
  },
  unauthorized: {
    title: 'Geen toegang',
    body: 'Je account heeft geen toegang tot dit portaal. Neem contact op met je coach of beheerder als je denkt dat dit een fout is.',
    uitloggen: 'Uitloggen',
  },
  rooster: {
    title: 'Rooster',
    weekVan: 'Week van',
    tm: 't/m',
    vorigeWeek: '← Vorige week',
    vandaag: 'Vandaag',
    volgendeWeek: 'Volgende week →',
    vol: 'VOL',
    geannuleerd: 'GEANNULEERD',
    foutLaden: 'Fout bij laden rooster: ',
    min: 'min',
    omschrijving: 'Omschrijving',
    nieuweLes: '+ Nieuwe les',
    prospectPrefix: '[Prospect]',
    filterAll: 'Alle',
    filterGroup: 'Groepslessen',
    filterPersonal: 'PT-afspraken',
    filterWorkshop: 'Workshops',
    trialBanner: 'Proeftraining plannen voor {naam} — selecteer een groepsles en klik op "Client inschrijven".',
    trialBannerWis: 'Wissen',
  },
  clientRooster: {
    title: 'Rooster',
    weekVan: 'Week van',
    tm: 't/m',
    vorigeWeek: '← Vorige week',
    vandaag: 'Vandaag',
    volgendeWeek: 'Volgende week →',
    inschrijven: 'Inschrijven',
    uitschrijven: 'Uitschrijven',
    opWachtlijst: 'Op wachtlijst',
    vol: 'Vol',
    ingeschreven: 'Ingeschreven',
    geannuleerd: 'Geannuleerd',
    verlopen: 'Verlopen',
    gevolgd: 'Gevolgd',
    plaatsen: 'plaatsen',
    ingeschrevenSucces: 'Je bent succesvol ingeschreven voor de les.',
    uitgeschrevenSucces: 'Je bent uitgeschreven voor de les.',
    wachtlijstGeplaatst: 'Les is vol — je bent op de wachtlijst geplaatst.',
    foutInschrijven: 'Fout bij inschrijven: ',
    foutUitschrijven: 'Fout bij uitschrijven: ',
    foutLaden: 'Fout bij laden rooster: ',
    foutGeenLidmaatschap: 'Je hebt geen actief lidmaatschap.',
    foutOnvoldoendeCredits: 'Onvoldoende credits om in te schrijven.',
    foutDeadlineVerstreken: 'De annuleringstermijn voor deze les is verstreken.',
    foutLesBestaat: 'Les niet gevonden of geannuleerd.',
    foutNietIngeschreven: 'Je bent niet ingeschreven voor deze les.',
    foutLesVerleden: 'Inschrijven op een les in het verleden is niet mogelijk.',
    foutAccountGeblokkeerd: 'Je account is geblokkeerd wegens een openstaande incasso. Neem contact op met de gym.',
    min: 'min',
    coach: 'Coach',
    credits: 'credits',
    creditsResterend: 'credits resterend',
    accountGeblokkeerd: 'Je account is tijdelijk geblokkeerd. Neem contact op met je coach.',
  },
  clients: {
    title: 'Cliënten',
    // F4-10: toegestane betaalmethoden per client
    betaalmethodenTitel: 'Toegestane betaalmethoden',
    betaalmethodenHint: 'Bepaal welke van de systeembreed ingeschakelde betaalmethoden deze cliënt mag kiezen bij het ondertekenen. Handmatige betaling is altijd beschikbaar.',
    betaalmethodenGeenSysteem: 'Er zijn systeembreed geen online betaalmethoden ingeschakeld. Alleen handmatige betaling is beschikbaar. Schakel iDEAL of SEPA in bij de systeeminstellingen om hier een keuze te maken.',
    betaalmethodenRadioAlle: 'Alle beschikbare methoden (geen beperking)',
    betaalmethodenRadioAangepast: 'Aangepast — alleen geselecteerde methoden',
    betaalmethodenLabelHandmatig: 'Handmatig (altijd beschikbaar)',
    betaalmethodenLabelIdeal: 'iDEAL',
    betaalmethodenLabelSepa: 'SEPA-incasso',
    betaalmethodenSysteemUit: 'systeembreed uitgeschakeld',
    betaalmethodenTooltipUit: 'Deze methode staat systeembreed uit en kan niet worden geselecteerd.',
    betaalmethodenOpslaan: 'Betaalmethoden opslaan',
    betaalmethodenOpgeslagen: 'Betaalmethoden voor cliënt opgeslagen.',
    betaalmethodenFout: 'Fout bij opslaan betaalmethoden: ',
    aantalGevonden: 'cliënten gevonden',
    zoekPlaceholder: 'Zoeken op naam or e-mail…',
    filterAll: 'Alle',
    filterActive: 'Actief',
    filterProspect: 'Prospects',
    filterInactive: 'Inactief',
    statusActive: 'Actief',
    statusProspect: 'Prospect',
    statusInactive: 'Inactief',
    statusVerwijderd: 'Verwijderd',
    foutLaden: 'Fout bij laden cliënten: ',
    // Foutcodes van de Edge Functions create-client / delete-client
    efFoutGeenAutorisatie: 'Geen autorisatie — log opnieuw in.',
    efFoutOngeldigeToken: 'Je sessie is verlopen. Log opnieuw in en probeer het nogmaals.',
    efFoutProfielNietGevonden: 'Je eigen profiel kon niet worden gevonden. Neem contact op met de beheerder.',
    efFoutGeenToegang: 'Je hebt geen rechten om cliënten aan te maken.',
    efFoutVerplichteVelden: 'Naam en e-mailadres zijn verplicht.',
    efFoutOngeldigeRol: 'De gekozen rol bestaat niet.',
    efFoutGeenRechtenVoorRol: 'Je hebt geen rechten om een gebruiker met deze rol aan te maken.',
    efFoutCoachVerplicht: 'Kies een coach — zonder coach is de cliënt niet zichtbaar in de portal.',
    efFoutAbonnementVerplicht: 'Kies een abonnement; dat is verplicht voor een actieve cliënt.',
    efFoutEmailInGebruik: 'Dit e-mailadres is al in gebruik door een bestaande gebruiker. Gebruik een ander adres, of verwijder eerst de bestaande gebruiker.',
    efFoutGebruikerAanmakenMislukt: 'De gebruiker kon niet worden aangemaakt. Probeer het opnieuw.',
    efFoutProfielUpdateMislukt: 'Het profiel kon niet worden opgeslagen. De cliënt is niet aangemaakt; je kunt het opnieuw proberen.',
    efFoutCoachKoppelingMislukt: 'De koppeling met de coach kon niet worden gemaakt. De cliënt is niet aangemaakt; je kunt het opnieuw proberen.',
    efFoutAbonnementstypeNietGevonden: 'Het gekozen abonnementstype bestaat niet (meer). De cliënt is niet aangemaakt; kies een ander abonnement.',
    efFoutLidmaatschapMislukt: 'Het lidmaatschap kon niet worden aangemaakt. De cliënt is niet aangemaakt; je kunt het opnieuw proberen.',
    efFoutAanmakenMislukt: 'Er ging iets mis bij het aanmaken. De cliënt is niet aangemaakt; je kunt het opnieuw proberen.',
    efFoutAuthVerwijderenMislukt: 'De gegevens van de cliënt zijn verwijderd, maar het inlogaccount kon niet worden verwijderd. Het e-mailadres blijft daardoor bezet — meld dit bij de beheerder.',
    efFoutRollbackMislukt: 'Let op: het e-mailadres is nu wél bezet door een onvolledig account. Meld dit bij de beheerder voordat je het opnieuw probeert.',
    efFoutOnbekend: 'Onbekende fout bij het aanmaken van de cliënt.',
    // Foutteksten voor het verwijder-/anonimiseerpad — bewust gescheiden van de
    // aanmaakteksten hierboven (zie clientAanmaakFouten.js).
    efFoutVerwijderOnbekend: 'Onbekende fout bij het verwijderen van dit account.',
    efFoutVerwijderGeenId: 'Er is geen gebruiker geselecteerd om te verwijderen.',
    efFoutVerwijderGekoppeld: 'Dit account kan niet verwijderd worden omdat er nog gegevens aan gekoppeld zijn (bijvoorbeeld lessen, afspraken, facturen of overeenkomsten). Ontkoppel of verwijder die eerst, of gebruik "Account verwijderen" — dan blijven de gegevens bewaard en worden alleen de persoonsgegevens gewist.',
    efFoutVerwijderStaf: 'Een coach- of beheerdersaccount kan niet definitief verwijderd worden: gekoppelde lessen, afspraken en administratie moeten bewaard blijven. Gebruik "Account verwijderen" — de persoonsgegevens worden gewist en inloggen wordt geblokkeerd.',
    efFoutVerwijderNogGekoppeld: 'Dit account is nog gekoppeld als coach ({onderdelen}). Wijs die eerst toe aan een andere coach of gebruik "Account verwijderen".',
    efFoutVerwijderDeelLessen: '{aantal} les(sen)',
    efFoutVerwijderDeelAanvragen: '{aantal} PT-aanvra(a)g(en)',
    efFoutVerwijderDeelOvereenkomsten: '{aantal} aangemaakte overeenkomst(en)',
    colNaam: 'Naam',
    colKlantnummer: 'Klantnr.',
    colEmail: 'E-mail',
    emailAutomatiseringTitel: 'E-mail automatisering',
    emailAutomatiseringRadioSysteem: 'Volgt systeeminstelling',
    emailAutomatiseringRadioAangepast: 'Aangepast',
    emailAutomatiseringLabelReminder: 'Herinnering automatisch versturen',
    emailAutomatiseringLabelFinalNotice: 'Aanmaning automatisch versturen',
    emailAutomatiseringOpslaan: 'Opslaan',
    emailAutomatiseringOpgeslagen: 'E-mail automatisering instellingen opgeslagen.',
    emailAutomatiseringFout: 'Fout bij opslaan e-mail automatisering: ',
    emailAutomatiseringHint: 'Bij "Aangepast" wijken deze instellingen af van de systeeminstellingen. Bij "Volgt systeeminstelling" worden de standaard instellingen gebruikt.',
    agrReminderTitel: 'Overeenkomst herinneringen',
    agrReminderHint: 'Pas hier de herinnering-instellingen aan voor deze client. Laat op "Volgt systeeminstelling" staan om de globale instelling te gebruiken.',
    agrReminderEnabledLabel: 'Herinneringen inschakelen voor deze client',
    agrReminderIntervalLabel: 'Interval (dagen)',
    agrReminderMaxLabel: 'Maximum aantal herinneringen',
    agrReminderOpgeslagen: 'Overeenkomst herinnering instellingen opgeslagen.',
    agrReminderFout: 'Fout bij opslaan: ',
    colCoach: 'Coach',
    colLidmaatschap: 'Lidmaatschap',
    colGeldigTm: 'Geldig t/m',
    colCredits: 'Credits',
    geenResultaatZoek: 'Geen cliënten gevonden voor deze zoekopdracht.',
    geenClinten: 'Nog geen cliënten.',
    onbekend: 'Onbekend',
    geen: 'Geen',
    details: 'Details →',
    verwijderClient: 'Client verwijderen',
    verwijderConfirmTitel: 'Client definitief verwijderen',
    verwijderConfirmTekst: 'Weet je zeker dat je deze client wilt verwijderen? Alle gegevens inclusief facturen, overeenkomsten en credits worden permanent verwijderd.',
    verwijderWaarschuwing: 'Dit kan niet ongedaan worden gemaakt.',
    verwijderSuccess: 'Client succesvol verwijderd.',
    verwijderFout: 'Fout bij verwijderen: ',
    verwijderBezig: 'Verwijderen...',
    clipboardFout: 'Link kon niet worden gekopieerd.',
    toevoegenKnop: '+ Cliënt toevoegen',
    trialPopupTitel: 'Proeftraining inplannen?',
    trialPopupUitleg: 'Wil je direct een gratis proeftraining inplannen voor {naam}?',
    trialPopupJaPT: 'Ja, PT-training',
    trialPopupJaGroepsles: 'Ja, groepsles',
    trialPopupNee: 'Nee',
    modalTitelNieuw: 'Nieuwe cliënt toevoegen',
    labelVoornaam: 'Voornaam',
    labelAchternaam: 'Achternaam',
    labelEmail: 'E-mailadres',
    labelPhone: 'Telefoonnummer',
    labelWachtwoord: 'Wachtwoord',
    labelCoach: 'Coach toewijzen',
    labelType: 'Type',
    labelAbonnement: 'Abonnement',
    labelStartdatum: 'Startdatum lidmaatschap',
    typeActief: 'Actief lid',
    typeProspect: 'Prospect',
    placeholderVoornaam: 'Jan',
    placeholderAchternaam: 'de Vries',
    placeholderEmail: 'jan@voorbeeld.nl',
    placeholderPhone: '+31612345678',
    selecteerCoach: 'Selecteer coach…',
    selecteerAbonnement: 'Selecteer abonnement…',
    opslaan: 'Opslaan',
    annuleren: 'Annuleren',
    validatieVoornaam: 'Voornaam is verplicht.',
    validatieAchternaam: 'Achternaam is verplicht.',
    validatieEmail: 'E-mailadres is verplicht.',
    validatieCoach: 'Coach toewijzen is verplicht.',
    validatieAbonnement: 'Bij "Actief lid" is een abonnement verplicht.',
    foutAanmaken: 'Fout bij aanmaken cliënt: ',
    geenSessie: 'Sessie verlopen — log opnieuw in.',
    succesBericht: 'Cliënt succesvol aangemaakt.',
    wachtwoordTonenTitel: 'Wachtwoord voor {naam}',
    wachtwoordTonenUitleg: 'Dit wachtwoord is automatisch gegenereerd en wordt maar één keer getoond — noteer het of stuur het door.',
    wachtwoordTonenGemaild: 'Dit wachtwoord staat ook in de welkomstmail die zojuist is verstuurd.',
    wachtwoordTonenNietGemaild: 'Er is geen welkomstmail verstuurd — geef dit wachtwoord zelf door aan de cliënt.',
    wachtwoordTonenSluiten: 'Ik heb het genoteerd, sluiten',
    geenCoachesGevonden: 'Geen coaches gevonden.',
    geenAbonnementenGevonden: 'Geen abonnementen gevonden.',
    sectionAdres: 'Adresgegevens (optioneel)',
    labelStraat: 'Straat',
    labelHuisnummer: 'Huisnummer',
    labelPostcode: 'Postcode',
    labelWoonplaats: 'Woonplaats',
    labelStandaardLocatie: 'Standaard locatie',
    geenLocatie: 'Geen locatie',
    placeholderStraat: 'Bijv. Sportlaan',
    placeholderHuisnummer: 'Bijv. 12',
    placeholderPostcode: 'Bijv. 1234 AB',
    placeholderWoonplaats: 'Bijv. Amsterdam',
  },
  clientDetail: {
    terugNaarClients: '← Terug naar cliënten',
    onbekend: 'Onbekend',
    klantnummer: 'Klantnummer',
    lidmaatschap: 'Lidmaatschap',
    type: 'Type',
    status: 'Status',
    actief: 'Actief',
    verlopen: 'Verlopen',
    startdatum: 'Startdatum',
    einddatum: 'Einddatum',
    creditsResterend: 'Credits resterend',
    ptCreditsLabel: 'PT-credits',
    ptPlusCreditsLabel: 'PT-plus credits',
    smallGroupCreditsLabel: 'Small Group credits',
    geenLidmaatschap: 'Geen actief lidmaatschap gevonden.',
    overzicht: 'Overzicht',
    creditbewegingen: 'Creditbewegingen',
    last20: 'laatste transacties',
    facturenTotaal: 'totaal',
    openstaand: 'Openstaand',
    facturenLabel: 'facturen',
    creditgeschiedenisTitel: 'Creditgeschiedenis (laatste 20)',
    creditbewegingenTitel: 'Creditbewegingen',
    geenTransacties: 'Geen transacties gevonden.',
    colDatum: 'Datum',
    colMutatie: 'Mutatie',
    colReden: 'Reden',
    colNotitie: 'Notitie',
    facturen: 'Facturen',
    geenFacturen: 'Geen facturen gevonden.',
    colNummer: 'Nummer',
    colPeriode: 'Periode',
    colTotaal: 'Totaal',
    colStatus: 'Status',
    overeenkomstenTitel: 'Overeenkomsten',
    geenOvereenkomsten: 'Nog geen overeenkomsten ondertekend.',
    colOndertekenddatum: 'Ondertekend op',
    colAbonnementstype: 'Abonnementstype',
    colActies: 'Acties',
    downloadPdf: 'Download PDF',
    clientNietGevonden: 'Cliënt niet gevonden',
    geenToegang: 'Je hebt geen toegang tot dit cliëntprofiel.',
    foutLaden: 'Fout bij laden cliëntdetail: ',
    nieuweFactuur: '+ Nieuwe factuur aanmaken',
    creditsTitel: 'Credits',
    creditsHuidig: 'Huidige creditbalans',
    creditsBijschrijven: 'Credits bijschrijven',
    creditsAfschrijven: 'Credits afschrijven',
    poolPT: '1-op-1 PT',
    poolPTPlus60: '1-op-2 PT (60 min)',
    poolPTPlus30: '1-op-2 PT (30 min)',
    poolSmallGroup: 'Small Group',
    geenCreditPools: 'Geen actieve abonnementen met credits.',
    creditModalTitelBij: 'Credits bijschrijven',
    creditModalTitelAf: 'Credits afschrijven',
    creditModalAantal: 'Aantal credits',
    creditModalReden: 'Reden',
    creditModalOpslaan: 'Opslaan',
    creditModalAnnuleren: 'Annuleren',
    creditSuccesBij: 'Credits bijgeschreven.',
    creditSuccesAf: 'Credits afgeschreven.',
    creditFoutGeenLidmaatschap: 'Geen actief lidmaatschap gevonden.',
    creditFoutOnvoldoende: 'Onvoldoende credits.',
    creditFoutAantal: 'Voer een geldig aantal in (minimaal 1).',
    creditFoutOpslaan: 'Fout bij bijwerken credits: ',
    creditModalKiesAbonnement: 'Abonnement',
    creditModalKiesAbonnementPlaceholder: 'Kies een abonnement…',
    creditFoutKiesAbonnement: 'Selecteer een abonnement.',
    persoonsgegevens: 'Persoonsgegevens',
    bewerken: 'Bewerken',
    opslaan: 'Opslaan',
    annuleren: 'Annuleren',
    labelVolledigeNaam: 'Volledige naam',
    labelEmail: 'E-mailadres (alleen lezen)',
    labelTelefoon: 'Telefoonnummer',
    labelStandaardLocatie: 'Standaard locatie',
    geenLocatie: 'Geen locatie',
    labelStraat: 'Straat',
    labelHuisnummer: 'Huisnummer',
    labelPostcode: 'Postcode',
    labelWoonplaats: 'Woonplaats',
    persoonOpslaanFout: 'Fout bij opslaan persoonsgegevens: ',
    persoonOpslaanSucces: 'Persoonsgegevens opgeslagen.',
    lidmaatschapBewerken: 'Lidmaatschap aanpassen',
    labelAbonnementstype: 'Abonnementstype',
    labelStartdatum: 'Startdatum',
    labelEinddatum: 'Einddatum (optioneel)',
    labelStatusLidmaatschap: 'Status',
    lidmaatschapActief: 'Actief',
    lidmaatschapInactief: 'Inactief',
    lidmaatschapOpslaanFout: 'Fout bij opslaan lidmaatschap: ',
    lidmaatschapOpslaanSucces: 'Lidmaatschap opgeslagen.',
    selecteerType: 'Selecteer een type…',
    afspraken: 'Afspraken',
    ptAfspraakInplannen: 'PT-afspraak inplannen',
    geenAfspraken: 'Geen afspraken gevonden.',
    badgeGroepsles: 'Groepsles',
    badgePT: 'PT',
    badgeWorkshop: 'Workshop',
    badgeAankomend: 'Aankomend',
    badgeGevolgd: 'Gevolgd',
    colAfspraakNaam: 'Les / afspraak',
    colAfspraakDatum: 'Datum & tijd',
    colAfspraakType: 'Type',
    colAfspraakLocatie: 'Locatie',
    colAfspraakStatus: 'Status',
    toonMeer: 'Toon meer',
    toonMinder: 'Toon minder',
    foutAfspraken: 'Fout bij laden afspraken: ',
    btwLabel: 'BTW:',
    btwMaandprijsIncl: 'Maandprijs incl.:',
    afsprakenAankomend: 'Aankomend',
    afsprakenGeschiedenis: 'Geschiedenis',
    geenAankomend: 'Geen aankomende afspraken.',
    geenGeschiedenisTabel: 'Geen afspraken in de geschiedenis.',
    handmatigVerlengingInfo: 'Verlenging en creditverstrekking gaan automatisch via de dagelijkse cron job.',
    opzeggenKnop: 'Abonnement opzeggen',
    opzeggenBevestiging: 'Weet je zeker dat je het abonnement van {naam} wilt opzeggen? Het abonnement loopt door tot {datum} en stopt daarna automatisch.',
    opzeggenSucces: 'Abonnement succesvol opgezegd.',
    opzeggenFout: 'Fout bij opzeggen: ',
    opzeggenPushTitel: 'Abonnement opgezegd',
    opzeggenPushBody: 'Je abonnement is opgezegd door je coach. Je hebt nog toegang tot {datum}.',
    opgezegd: 'Opgezegd — loopt af op {datum}',
    lidmaatschapGeschiedenisTitel: 'Lidmaatschapsgeschiedenis',
    customVoorwaarden: 'Aangepaste voorwaarden',
    customVoorwaardenInfo: 'Maak een abonnement op maat met afwijkende prijs, credits of looptijd.',
    customNaam: 'Aangepaste naam (optioneel)',
    customPrijs: 'Prijs (€)',
    customCredits: 'Credits per periode',
    customLooptijd: 'Looptijd (dagen)',
    customOpslaanAlsType: 'Sla ook op als nieuw standaard abonnementstype',
    customVoorwaardenPrijsVerplicht: 'Prijs is verplicht bij aangepaste voorwaarden.',
    customVoorwaardenCreditsVerplicht: 'Credits zijn verplicht bij aangepaste voorwaarden.',
    customVoorwaardenLooptijdVerplicht: 'Looptijd is verplicht bij aangepaste voorwaarden.',
    badgeAangepast: 'Aangepast',
    lidmaatschapGeenGeschiedenis: 'Nog geen geschiedenis beschikbaar.',
    colHistDatum: 'Datum',
    colHistType: 'Type wijziging',
    colHistStartdatum: 'Startdatum',
    colHistEinddatum: 'Einddatum',
    bannierIncasso: '⚠ Account geblokkeerd — openstaande incasso. Bekijk de facturen voor details.',
    membReminderTitel: 'Herinneringen',
    membReminderHint: 'Stel in wanneer deze cliënt herinneringen ontvangt vóór de automatische verlenging van het abonnement.',
    membReminderSysteem: 'Systeemdefault',
    membReminderAangepast: 'Aangepast schema',
    membReminderUitgeschakeld: 'Herinneringen uitschakelen',
    membReminderDagen: 'dagen',
    membReminderWettelijk: 'De bevestiging op de dag van verlenging wordt altijd verstuurd (wettelijke vereiste).',
    membReminderOpgeslagen: 'Herinneringsinstelling opgeslagen.',
    membReminderFout: 'Fout bij opslaan herinnering: ',
    badgeGeblokkeerd: 'Geblokkeerd',
    foutProfielVerwijderd: 'Dit profiel is verwijderd en kan niet meer bewerkt worden.',
    bannerProfielVerwijderd: 'Dit profiel is op {datum} verwijderd (geanonimiseerd) door de cliënt of een coach. Persoonsgegevens zijn gewist; facturen, abonnementen en overeenkomsten blijven bewaard voor de bewaarplicht.',
    blokkeringOpheffen: 'Blokkering opheffen',
    blokkeringOpheffenBevestiging: 'Weet je zeker dat je de blokkering van {naam} wilt opheffen? Er staan mogelijk nog openstaande incasso-facturen.',
    blokkeringOpgeheven: 'Blokkering is opgeheven. De client heeft weer volledige toegang.',
    blokkeringOpheffenFout: 'Fout bij opheffen blokkering: ',
    // Lidmaatschap nieuw 3-acties model
    staffelLabel: '{months} maand{suffix}',
    staffelLabelMet: '{type} — {months} maand{suffix}',
    pricePerPeriod: 'Prijs per periode',
    pricePerMonth: 'Prijs per maand',
    creditsPerPeriod: 'Credits per periode',
    laatsVerlenging: 'Laatste verlenging',
    nogNietVerlengd: 'Nog niet verlengd',
    volgendeVerlenging: 'Volgende verlenging',
    opzegdatum: 'Opzegdatum',
    initialEndDate: 'Initiële einddatum',
    isRolling: 'Maandelijks opzegbaar',
    autoRenewLabel: 'Automatisch verlengen',
    reminderDaysLabel: 'Herinneringsdagen',
    lidmaatschapBeeindigen: 'Lidmaatschap beëindigen',
    // F4-10 stap4a: payment_method wijzigen op bestaande membership
    betaalmethodeLabel: 'Betaalmethode',
    betaalmethodeWijzigen: 'Wijzigen',
    betaalmethodeBevestigen: 'Bevestigen',
    betaalmethodeAnnuleren: 'Annuleren',
    betaalmethodeOpgeslagen: 'Betaalmethode gewijzigd.',
    betaalmethodeFout: 'Fout bij wijzigen betaalmethode: ',
    betaalmethodeSepaHint: 'SEPA-incasso is via deze weg nog niet beschikbaar — dit komt binnenkort via de mandaatflow.',
    beeindigenModalTitel: 'Lidmaatschap beëindigen',
    beeindigenPerEindeContract: 'Per einde contract ({datum})',
    beeindigenPerEindeMaand: 'Einde lopende periode ({datum})',
    beeindigenPerDatum: 'Per aangepaste datum',
    beeindigenDatumLabel: 'Einddatum (minimaal morgen)',
    beeindigenBevestigen: 'Beëindigen bevestigen',
    beeindigenAnnuleren: 'Annuleren',
    beeindigenSucces: 'Abonnement beëindigd.',
    beeindigenFout: 'Fout bij beëindigen: ',
    lidmaatschapNieuw: 'Nieuw lidmaatschap',
    nieuwModalTitel: 'Nieuw lidmaatschap toevoegen',
    nieuwLabelType: 'Abonnementstype',
    nieuwSelecteerType: 'Selecteer een type…',
    nieuwLabelStaffel: 'Staffel (looptijd & prijs)',
    nieuwSelecteerStaffel: 'Selecteer een staffel…',
    nieuwLabelStartdatum: 'Startdatum',
    nieuwLabelPrijs: 'Prijs per periode (€)',
    nieuwLabelCredits: 'Credits per periode',
    nieuwLabelWelkomstmail: 'Stuur welkomstmail',
    nieuwBevestigen: 'Lidmaatschap toevoegen',
    nieuwAnnuleren: 'Annuleren',
    nieuwSucces: 'Lidmaatschap aangemaakt.',
    nieuwFout: 'Fout bij aanmaken lidmaatschap: ',
    nieuwGeenStaffels: 'Geen actieve staffels voor dit type.',
    nieuwValidatieType: 'Selecteer een abonnementstype.',
    nieuwValidatieStaffel: 'Selecteer een staffel.',
    nieuwValidatieStartdatum: 'Startdatum is verplicht.',
    nieuwCustomBadge: 'Aangepaste prijs/credits',
    lidmaatschapHistorieTitel: 'Lidmaatschapshistorie',
    historieGeenData: 'Geen lidmaatschapshistorie beschikbaar.',
    historieColType: 'Type',
    historieColStaffel: 'Staffel',
    historieColPeriode: 'Periode',
    historieColPrijs: 'Prijs',
    historieColCredits: 'Credits',
    historieColStatus: 'Status',
    historieColStart: 'Start',
    historieColEind: 'Eind',
    historieStatusActief: 'Actief',
    historieStatusVerlopen: 'Verlopen',
    historieStatusOpgezegd: 'Opgezegd',
    historieOnbekendType: 'Onbekend',
    historieGeschiedenisLabel: 'Laad historiek',
  },
  facturen: {
    title: 'Facturering',
    aantalFacturen: 'facturen',
    nieuweFactuur: '+ Nieuwe factuur',
    alleStatussen: 'Alle statussen',
    alleClients: 'Alle cliënten',
    geenFacturen: 'Geen facturen gevonden.',
    colNummer: 'Nummer',
    colClient: 'Cliënt',
    colPeriode: 'Periode',
    colDatum: 'Datum',
    colTotaal: 'Totaal',
    colStatus: 'Status',
    colActies: 'Acties',
    modalTitel: 'Nieuwe factuur aanmaken',
    labelClient: 'Cliënt',
    selecteerClient: 'Selecteer een cliënt…',
    labelAbonnement: 'Koppel aan abonnement (optioneel)',
    geenAbonnementKoppeling: 'Geen koppeling — losse factuur',
    abonnementKoppelingHint: 'Bepaalt o.a. welk abonnement de SEPA-incasso/machtigingskenmerk gebruikt bij deze factuur.',
    labelPeriodeStart: 'Periode start',
    labelPeriodeEinde: 'Periode einde',
    labelBtwPercentage: 'BTW-percentage',
    btwOptie9: '9%',
    btwOptie21: '21%',
    regeloverzicht: 'Regeloverzicht',
    colOmschrijving: 'Omschrijving',
    colAantal: 'Aantal',
    colStukprijs: 'Stukprijs',
    colBtwPct: 'BTW%',
    colExcl: 'Excl. BTW',
    colBtw: 'BTW',
    colIncl: 'Incl. BTW',
    omschrijvingPlaceholder: 'Omschrijving',
    regelToevoegen: '+ Regel toevoegen',
    subtotaal: 'Subtotaal excl. BTW',
    btw: 'BTW',
    totaalIncl: 'Totaal incl. BTW',
    annuleren: 'Annuleren',
    opslaan: 'Opslaan…',
    aanmaken: 'Factuur aanmaken',
    markeerVerzonden: 'Markeer verzonden',
    markeerBetaald: 'Markeer betaald',
    genererenPdf: 'Genereren…',
    verstuurFactuur: 'Verstuur factuur',
    downloadPdf: 'Download PDF',
    verstuurHerinnering: 'Verstuur herinnering',
    verstuurAanmaning: 'Verstuur aanmaning',
    verstuurIncasso: 'Verstuur incasso',
    factuurVerstuurd: 'Factuur verstuurd',
    herinneringVerstuurd: 'Herinnering verstuurd',
    aanmaningVerstuurd: 'Aanmaning verstuurd',
    incassoVerstuurd: 'Incasso verstuurd',
    blokkeringGeactiveerd: 'Account van de client is geblokkeerd.',
    blokkeringOpgeheven: 'Blokkering opgeheven. Client heeft weer volledige toegang.',
    pdfGedownload: 'PDF gedownload',
    foutLaden: 'Fout bij laden facturen: ',
    foutAanmaken: 'Fout bij aanmaken factuur: ',
    foutStatus: 'Fout bij statuswijziging: ',
    foutUpload: 'Fout bij uploaden van de factuur-PDF. De factuur is NIET verstuurd. Probeer het opnieuw: ',
    foutStatusNaUpload: 'De PDF is opgeslagen, maar de statuswijziging mislukte. De factuur is niet als verstuurd gemarkeerd. Probeer het opnieuw: ',
    validatieClient: 'Selecteer een cliënt.',
    validatieRegels: 'Vul alle regelomschrijvingen en prijzen in.',
    validatieDatum: 'Einddatum moet na startdatum liggen.',
    stukprijsExcl: 'Excl.',
    stukprijsIncl: 'Incl.',
    exclRef: 'excl.:',
    verwijderen: 'Verwijderen',
    verwijderenTitel: 'Concept verwijderen',
    verwijderenTekst: 'Weet je zeker dat je deze concept-factuur wilt verwijderen? Dit kan niet ongedaan worden gemaakt.',
    verwijderenSucces: 'Factuur verwijderd.',
    foutVerwijderen: 'Fout bij verwijderen: ',
    creditnota: 'Creditnota',
    creditnotaTitel: 'Creditnota aanmaken',
    creditnotaTekstPrefix: 'Wil je een creditnota aanmaken voor factuur',
    creditnotaTekstSuffix: '? De originele factuur blijft bestaan. De creditnota neutraliseert het openstaande bedrag.',
    creditnotaSucces: 'Creditnota aangemaakt:',
    foutCreditnota: 'Fout bij aanmaken creditnota: ',
    badgeCreditnota: 'Creditnota',
    bijFactuur: 'Bij factuur',
    herinneringPdf: 'Herinnering PDF',
    bevestigen: 'Bevestigen',
    herinneringModalTitel: 'Betalingsherinnering registreren',
    aanmaningModalTitel: 'Laatste aanmaning registreren',
    herinneringModalLoading: 'Herinnering registreren…',
    herinneringModalSucces: 'De herinnering is geregistreerd. Download de PDF hieronder.',
    herinneringModalDownload: '⬇ Download PDF',
    herinneringModalSluiten: 'Sluiten',
    herinneringKnop: 'Herinnering PDF',
    aanmaningKnop: 'Laatste aanmaning PDF',
    incassoKnop: 'Overdragen aan incasso',
    incassoTitel: 'Dossier overdragen aan incasso',
    incassoTekst: 'Weet je zeker dat je dit dossier overdraagt aan een incassobureau? Dit wordt gelogd.',
    incassoBevestigen: 'Overdragen',
    incassoSucces: 'Dossier overgedragen aan incasso.',
    herinneringGeschieden: 'Geschiedenis',
    histTypeReminder: 'Herinnering verstuurd',
    histTypeFinalNotice: 'Laatste aanmaning verstuurd',
    histTypeCollections: 'Overgedragen aan incasso',
    histNieuweBetaaldatum: 'Nieuwe betaaldatum:',
    herinneringFoutLaden: 'Fout bij registreren: ',
    betaaldBevestigenTitel: 'Factuur markeren als betaald',
    betaaldBevestigenKnop: 'Ja, markeer betaald',
    collectionsNaarBetaaldTekst: 'Weet je zeker dat je deze factuur als betaald wilt markeren? De incasso-overdracht wordt hiermee afgesloten.',
    markeerBetaaldIncasso: 'Markeer als betaald',
    onbetaaldKnop: 'Markeer onbetaald',
    onbetaaldTitel: 'Factuur terugzetten naar Verzonden',
    onbetaaldKnopBevestigen: 'Ja, zet terug',
    foutOnbetaald: 'Fout bij terugzetten: ',
    gedeeltelijkBetaald: 'Gedeeltelijk betaald',
    gedeeltelijkModalTitel: 'Gedeeltelijke betaling registreren',
    gedeeltelijkTotaal: 'Totaalbedrag',
    gedeeltelijkBetaaldLabel: 'Reeds betaald',
    gedeeltelijkOpenstaand: 'Openstaand',
    gedeeltelijkOpslaan: 'Opslaan',
    gedeeltelijkFout: 'Fout bij opslaan: ',
    gedeeltelijkValidatie: 'Voer een geldig bedrag in.',
    volledigBetaaldKnop: 'Volledig betaald',
    volledigBetaaldTitel: 'Factuur als volledig betaald markeren',
    volledigBetaaldTekst: 'Weet je zeker dat je deze factuur als volledig betaald wilt markeren?',
    volledigBetaaldBevestigen: 'Ja, volledig betaald',
    betaaldInfoLabel: 'Betaald:',
    openstaandInfoLabel: 'Open:',
    pushVersturen: 'Push notificatie versturen naar cliënt',
    pushTekstLabel: 'Berichttekst',
    registrerenEnDownloadBtn: 'Registreer & download PDF',
    testmodusLabel: '⚠ Testmodus: wachtdagen worden genegeerd',
    downloadBevestigenTitel: 'Status wijzigen zonder e-mail',
    downloadBevestigenTekst: 'Wil je de status wijzigen naar {status}? De PDF wordt gedownload maar er wordt geen e-mail verstuurd.',
    downloadBevestigenStatus: {
      draft: 'Verzonden',
      reminder: 'Herinnering verstuurd',
      final_notice: 'Aanmaning verstuurd',
      collections: 'Incasso',
    },
    downloadBevestigenJa: 'Bevestigen',
    downloadBevestigenAlleenPdf: 'Alleen PDF downloaden',
    pushModalTitel: 'Wil je ook een pushbericht sturen naar [naam]?',
    pushModalLabel: 'Berichttekst',
    pushModalHint: 'Deze tekst is afkomstig uit de E-mail automatisering instellingen en kan hier worden aangepast voor dit specifieke bericht.',
    pushModalOverslaan: 'Overslaan',
    pushModalVerstuur: 'Verstuur push',
    pushAanmaningTitle: 'Laatste aanmaning',
    pushValidatie: 'Voer een berichttekst in.',
    pushGeenToken: 'Cliënt heeft geen push token. Kan geen notificatie versturen.',
    pushFout: 'Fout bij versturen push: ',
  },
  banner: {
    openstaandeAanmaning: 'U heeft een openstaande aanmaning.',
    bekijkFacturen: 'Bekijk facturen',
    openstaandeOvereenkomst: 'Er staat een overeenkomst klaar voor je handtekening.',
    bekijkOvereenkomst: 'Bekijk en onderteken',
  },
  mijnFacturen: {
    title: 'Mijn Facturen',
    aantalFacturen: 'facturen',
    geenFacturen: 'Geen facturen gevonden.',
    colNummer: 'Nummer',
    colDatum: 'Datum',
    colTotaal: 'Totaal',
    colStatus: 'Status',
    foutLaden: 'Fout bij laden facturen: ',
    genererenPdf: 'Genereren…',
    downloadFactuur: 'Download factuur',
    histTypeReminder: 'Betalingsherinnering verstuurd',
    histTypeFinalNotice: 'Laatste aanmaning verstuurd',
    histTypeCollections: 'Overgedragen aan incasso',
    histNieuweBetaaldatum: 'Nieuwe betaaldatum:',
  },
  status: {
    draft: 'Concept',
    sent: 'Verzonden',
    paid: 'Betaald',
    reminded: 'Herinnerd',
    final_notice: 'Laatste aanmaning',
    collections: 'Overgedragen aan incasso',
    partially_paid: 'Gedeeltelijk betaald',
  },
  creditReasons: {
    lesson_enrollment:      'Les ingeboekt',
    lesson_unenroll_refund: 'Terugboeking uitschrijving',
    manual_deduct:          'Handmatige afschrijving',
    manual_grant:           'Handmatige bijschrijving',
    manual_reset:           'Credits gereset',
    grant_initial:          'Initiële credits bij abonnement',
    custom_grant:           'Aanvullende afspraak bij overeenkomst',
    grant_renewal:          'Bijschrijving bij verlenging',
    deduct:                 'Afschrijving',
    refund:                 'Terugboeking',
  },
  mijnCredits: {
    title: 'Mijn Credits',
    balans: 'credits resterend',
    geenLidmaatschap: 'Geen actief lidmaatschap gevonden.',
    geschiedenisTitel: 'Creditgeschiedenis',
    colDatum: 'Datum',
    colReden: 'Reden',
    colAantal: 'Aantal',
    geenGeschiedenis: 'Geen creditgeschiedenis gevonden.',
    foutLaden: 'Fout bij laden creditgeschiedenis: ',
  },
  pdf: {
    factuur: 'Factuur',
    van: 'Van',
    aan: 'Aan',
    factuurdatum: 'Factuurdatum',
    periode: 'Periode',
    btwPercentage: 'BTW-percentage',
    omschrijving: 'Omschrijving',
    aantal: 'Aantal',
    stukprijs: 'Stukprijs',
    totaal: 'Totaal',
    colExcl: 'Totaal excl.',
    colBtw: 'BTW',
    colIncl: 'Totaal incl.',
    colBtwPct: 'BTW%',
    subtotaal: 'Subtotaal',
    btw: 'BTW',
    totaalTeBetalen: 'Totaal te betalen',
    geenRegeldetails: 'Geen regeldetails beschikbaar.',
    pagina: 'Pagina',
    van2: 'van',
    kvk: 'KvK',
    btwnr: 'Btw-nr',
    brandTagline: 'Personal Training & Groepslessen',
    betaalgegevens: 'Betaalgegevens',
    factuurdetails: 'Factuurdetails',
    teBetalen: 'Te betalen',
    voor: 'voor',
    naarIban: 'IBAN',
    opNaamVan: 'Op naam van',
    omschrijvingBet: 'Omschrijving',
    factuurnummer: 'Factuurnummer',
    factuurdatumLabel: 'Factuurdatum',
    betalingstermijn: 'Betalingstermijn',
    klantnummer: 'Klantnummer',
    dagen: 'dagen',
    btwSpecificatie: 'BTW-specificatie',
    btwPercent: 'Btw %',
    grondslag: 'Grondslag',
    bedrag: 'Bedrag',
    totaalExclBtw: 'Totaal excl. btw',
    totaalBtw: 'Totaal btw',
    totaalInclBtw: 'Te betalen',
    betalingsherinnering: 'Betalingsherinnering',
    herinneringSubtitel: 'is nog niet voldaan',
    herinneringTekst1: 'Wij hebben geconstateerd dat onderstaande factuur nog niet is voldaan. Wij verzoeken u vriendelijk het openstaande bedrag van',
    herinneringTekst2: 'vóór',
    herinneringTekst3: 'over te maken op onderstaand rekeningnummer.',
    openstaand: 'Openstaand',
    vervaldatum: 'Vervaldatum',
    oorspronkelijkeRegels: 'Originele factuurregels',
    laaststeAanmaning: 'Laatste aanmaning',
    laaststeAanmaningSubtitel: 'is ondanks eerdere herinnering onbetaald',
    aanmaningTekst1: 'Ondanks onze betalingsherinnering hebben wij uw betaling nog niet ontvangen. Wij sommeren u hierbij het openstaande bedrag van',
    aanmaningTekst2: 'uiterlijk op',
    aanmaningTekst3: 'te voldoen.',
    aanmaningTekst4: 'Bij niet-tijdige betaling zijn wij genoodzaakt incassokosten in rekening te brengen conform de Wet Incassokosten (WIK). De minimale incassokosten bedragen € 40,00. Na het verstrijken van deze termijn wordt uw dossier overgedragen aan een incassobureau.',
  },
  instellingen: {
    title: 'Instellingen',
    subtitle: 'Beheer bedrijfsgegevens en logo',
    // F4-10: betaalmethoden (systeembreed)
    betaalmethodenTitel: 'Betaalmethoden',
    betaalmethodenUitleg: 'Bepaal welke online betaalmethoden systeembreed beschikbaar zijn. Handmatige betaling (factuur zonder online betaling) is altijd beschikbaar en staat niet in deze lijst.',
    betaalmethodenLabelIdeal: 'iDEAL inschakelen',
    betaalmethodenHintIdeal: 'Sta eenmalige iDEAL-betalingen toe bij het ondertekenen van een overeenkomst.',
    betaalmethodenLabelSepa: 'SEPA-incasso inschakelen',
    betaalmethodenHintSepa: 'Sta doorlopende SEPA-incassomachtigingen toe bij het ondertekenen van een overeenkomst.',
    betaalmethodenHandmatigInfo: 'Handmatige betaling blijft altijd beschikbaar, ongeacht deze instellingen.',
    betaalmethodenOpgeslagen: 'Betaalmethoden opgeslagen.',
    betaalmethodenFout: 'Fout bij opslaan betaalmethoden: ',
    // F4-10 Stap 2: waarschuwing bij uitschakelen van een betaalmethode
    betaalmethodenWaarschuwingIdealEnkelvoud: 'Let op: {aantal} actief abonnement gebruikt momenteel iDEAL. Bestaande abonnementen blijven gewoon doorlopen; er verandert niets automatisch.',
    betaalmethodenWaarschuwingIdealMeervoud: 'Let op: {aantal} actieve abonnementen gebruiken momenteel iDEAL. Bestaande abonnementen blijven gewoon doorlopen; er verandert niets automatisch.',
    betaalmethodenWaarschuwingSepaEnkelvoud: 'Let op: {aantal} actief abonnement gebruikt momenteel SEPA-incasso. Bestaande abonnementen blijven gewoon doorlopen; er verandert niets automatisch.',
    betaalmethodenWaarschuwingSepaMeervoud: 'Let op: {aantal} actieve abonnementen gebruiken momenteel SEPA-incasso. Bestaande abonnementen blijven gewoon doorlopen; er verandert niets automatisch.',
    // F4-10 SEPA-machtigingsaddendum: incassant-ID voor de machtigingstekst
    mollieIncassantIdLabel: 'Mollie incassant-ID',
    mollieIncassantIdPlaceholder: 'Bijv. NL12ZZZ123456780000',
    mollieIncassantIdWaarschuwing: 'Incassant-ID nog niet ingesteld — nodig voor een juridisch volledige machtiging vóór productiegebruik met echte incasso\'s.',
    bedrijfsgegevens: 'Bedrijfsgegevens',
    logo: 'Bedrijfslogo',
    labelBedrijfsnaam: 'Bedrijfsnaam',
    labelAdres: 'Adres',
    labelPostcode: 'Postcode',
    labelStad: 'Stad',
    labelKvk: 'KVK-nummer',
    labelBtw: 'BTW-nummer',
    labelIban: 'IBAN-rekeningnummer',
    labelEmail: 'E-mail',
    labelTelefoon: 'Telefoon',
    labelEmailFrom: 'Algemeen afzenderadres (fallback)',
    hintEmailFrom: 'Dit adres moet geverifieerd zijn in Resend. Wordt gebruikt als een van de onderstaande specifieke adressen leeg is gelaten.',
    labelEmailInvoices: 'Afzenderadres facturen',
    hintEmailInvoices: 'Afzenderadres voor facturen, herinneringen, aanmaningen en SEPA-herincassomails. Leeg = gebruik het algemene afzenderadres.',
    labelEmailAgreements: 'Afzenderadres overeenkomsten',
    hintEmailAgreements: 'Afzenderadres voor overeenkomst-e-mails: verzending, herinneringen en afwijzingsbevestigingen. Leeg = gebruik het algemene afzenderadres.',
    labelEmailNotifications: 'Afzenderadres notificaties',
    hintEmailNotifications: 'Afzenderadres voor overige systeemmails, zoals de welkomstmail en opzeggingsbevestigingen. Leeg = gebruik het algemene afzenderadres.',
    labelBetalingstermijn: 'Betalingstermijn (dagen)',
    labelFactuurvoetnoot: 'Factuurvoetnoot / opmerking',
    opslaan: 'Opslaan',
    opgeslagen: 'Instellingen opgeslagen.',
    foutLaden: 'Fout bij laden instellingen: ',
    foutOpslaan: 'Fout bij opslaan instellingen: ',
    logoHuidig: 'Huidig logo:',
    logoUpload: 'Logo uploaden (PNG/JPG, max 2 MB)',
    logoUploaden: 'Uploaden…',
    logoFoutGrootte: 'Bestand is te groot (max 2 MB).',
    logoFoutType: 'Alleen PNG of JPG toegestaan.',
    logoFoutUpload: 'Fout bij uploaden logo: ',
    logoGeenLogo: 'Nog geen logo geüpload.',
    factuurtekstenSectionTitel: 'Factuurteksten',
    factuurtekstenSectionSubtitel: 'Beheer alle teksten die op facturen en herinneringen verschijnen.',
    factuurtekstenBeheerLink: 'Factuurteksten beheren',
    emailtekstenSectionTitel: 'E-mailteksten',
    emailtekstenSectionSubtitel: 'Beheer de teksten en templates die in automatische e-mails worden gebruikt.',
    emailtekstenBeheerLink: 'E-mailteksten beheren',
    locatiebeheer: 'Locatiebeheer',
    locatieFoutLaden: 'Fout bij laden locaties: ',
    locatieFoutOpslaan: 'Fout bij opslaan locatie: ',
    locatieFoutToggle: 'Fout bij wijzigen locatiestatus: ',
    locatieNaamVerplicht: 'Vul een naam in.',
    bewerken: 'Bewerken',
    emailAutomatiseringTitel: 'E-mail automatisering',
    emailAutomatiseringSubtitel: 'Stel in welke factuur e-mails automatisch worden verstuurd via de dagelijkse cron job.',
    labelAutoReminder: 'Herinnering automatisch versturen',
    hintAutoReminder: 'Verstuur automatisch een betalingsherinnering 14 dagen na vervaldatum en wijzig de status naar "reminded".',
    labelAutoFinalNotice: 'Aanmaning automatisch versturen',
    hintAutoFinalNotice: 'Verstuur automatisch een laatste aanmaning na herinnering en wijzig de status naar "final_notice". Incasso-overdracht blijft altijd handmatig.',
    labelPushEnabled: 'Push notificatie versturen bij laatste aanmaning',
    hintPushEnabled: 'Verstuur automatisch een push notificatie naar de cliënt bij het registreren van een laatste aanmaning.',
    labelPushText: 'Standaard push berichttekst',
    hintPushDatum: '[datum] wordt automatisch vervangen door de nieuwe betaaldatum.',
    labelAutoRecurringInvoices: 'Facturen bij automatische verlengingen direct versturen',
    hintAutoRecurringInvoices: 'Facturen die de cron job aanmaakt bij automatische abonnementsverlengingen worden direct verstuurd en gemaild naar de cliënt, in plaats van als concept klaargezet te worden.',
    autoRecurringInvoicesConfirmTitel: 'Automatisch factureren inschakelen',
    autoRecurringInvoicesConfirmTekst: 'Weet je het zeker? Facturen gaan vanaf nu automatisch naar de klant.',
    opslaanEmailAutomatisering: 'Opslaan',
    emailAutomatiseringOpgeslagen: 'E-mail automatisering instellingen opgeslagen.',
    foutEmailAutomatisering: 'Fout bij opslaan e-mail automatisering: ',
    prospectHerinneringenTitel: 'Prospect opvolgherinneringen',
    prospectHerinneringenSubtitel: 'Stel in hoe vaak en wanneer prospects automatisch een opvolgherinnering ontvangen.',
    labelProspectReminderEnabled: 'Herinneringen versturen',
    hintProspectReminderEnabled: 'Verstuur automatisch opvolgherinneringen naar prospects na proefsessie.',
    labelProspectReminderInterval: 'Interval (dagen)',
    hintProspectReminderInterval: 'Aantal dagen tussen elke herinnering. Standaard 7 dagen.',
    labelProspectReminderMax: 'Maximum aantal herinneringen',
    hintProspectReminderMax: 'Maximaal aantal herinneringen dat wordt verstuurd per prospect. Standaard 3.',
    prospectHerinneringenOpgeslagen: 'Prospect opvolgherinneringen instellingen opgeslagen.',
    foutProspectHerinneringen: 'Fout bij opslaan prospect herinneringen: ',
    overeenkomstHerinneringenTitel: 'Overeenkomst herinneringen',
    overeenkomstHerinneringenUitleg: 'Stuur automatisch een herinnering als een client een openstaande overeenkomst heeft die nog niet is ondertekend.',
    labelAgreementReminderEnabled: 'Automatische herinneringen inschakelen',
    labelAgreementReminderInterval: 'Interval (dagen)',
    hintAgreementReminderInterval: 'Aantal dagen tussen herinneringen. Standaard 3 dagen.',
    labelAgreementReminderMax: 'Maximum aantal herinneringen',
    hintAgreementReminderMax: 'Maximaal aantal herinneringen per openstaand token. Standaard 2.',
    overeenkomstHerinneringenOpgeslagen: 'Overeenkomst herinnering instellingen opgeslagen.',
    foutOvereenkomstHerinneringen: 'Fout bij opslaan overeenkomst herinneringen: ',
    ontbrekendeTekstenTitel: 'Let op',
    ontbrekendeTekstenBody: 'Let op: Er is geen tekst beschikbaar voor één of meerdere herinneringen',
    naarTekstenPagina: 'Naar teksten-beheerpagina',
    algemeeneVoorwaardenTitel: 'Centrale algemene overeenkomstvoorwaarden',
    algemeeneVoorwaardenUitleg: 'Deze tekst wordt bij élke nieuwe overeenkomst bovenaan getoond, vóór de abonnements-specifieke voorwaarden. Gebruik dit voor juridische basistekst die voor alle typen geldt.',
    algemeeneVoorwaardenPlaceholder: 'Voer hier de algemene voorwaarden in die gelden voor alle overeenkomsten...',
    algemeeneVoorwaardenOpgeslagen: 'Algemene overeenkomstvoorwaarden opgeslagen.',
    foutAlgemeneVoorwaarden: 'Fout bij opslaan algemene voorwaarden: ',
    membReminderTitel: 'Standaard herinneringen abonnementsverlenging',
    membReminderUitleg: 'Stel in hoeveel dagen vóór de automatische verlenging cliënten een herinnering ontvangen. Dit is het systeemdefault; per cliënt kan een afwijkend schema worden ingesteld.',
    membReminderDagen: 'dagen',
    membReminderWettelijk: 'De bevestiging op de dag van verlenging wordt altijd verstuurd (wettelijke vereiste, Wet van Dam).',
    membReminderOpgeslagen: 'Herinneringsinstellingen opgeslagen.',
    membReminderFout: 'Fout bij opslaan herinneringen: ',
    expiryTitel: 'Vervaltijd uitnodigingen',
    expiryUitleg: 'Na hoeveel uur vervalt een onbevestigde lesuitnodiging automatisch? De client wordt per push op de hoogte gesteld.',
    expiryLabel: 'Uren tot vervallen',
    expiryOpgeslagen: 'Vervaltijd opgeslagen.',
    expiryFout: 'Fout bij opslaan vervaltijd: ',
    broadcastsTitel: 'Dagcap broadcasts',
    broadcastsUitleg: 'Maximaal aantal broadcast-pushberichten dat een coach per dag mag versturen. Beschermt tegen onbedoeld of overmatig versturen.',
    broadcastsLabel: 'Max. broadcasts per dag',
    broadcastsOpgeslagen: 'Dagcap broadcasts opgeslagen.',
    broadcastsFout: 'Fout bij opslaan dagcap broadcasts: ',
  },
  mijnLessen: {
    title: 'Mijn lessen',
    tabAankomend: 'Aankomend',
    tabGevolgd: 'Gevolgd',
    geenAankomend: 'Geen aankomende lessen gevonden.',
    geenGevolgd: 'Geen gevolgde lessen gevonden.',
    foutLaden: 'Fout bij laden lessen: ',
    colLes: 'Les',
    colDatumTijd: 'Datum & tijd',
    colLocatie: 'Locatie',
    colCoach: 'Coach',
    colStatus: 'Status',
    badgeAankomend: 'Aankomend',
    badgeWachtlijst: 'Wachtlijst',
    badgeGevolgd: 'Gevolgd',
    annuleerKnop: 'Annuleer',
    annuleerTitel: 'Inschrijving annuleren',
    annuleerBevestig: 'Weet je zeker dat je je wil uitschrijven voor deze les?',
    annuleerJa: 'Ja, uitschrijven',
    annuleerNee: 'Nee, behouden',
    annulerenBezig: 'Bezig…',
    annuleerFout: 'Fout bij annuleren: ',
    errNietIngeschreven: 'Je bent niet ingeschreven voor deze les.',
    errDeadlineVerstreken: 'De annuleringstermijn is verstreken.',
    errOnbekend: 'Er is een onbekende fout opgetreden.',
  },
  common: {
    laden: 'Laden…',
    pdf: '⬇ PDF',
    geen: '—',
    annuleren: 'Annuleren',
    bezig: 'Bezig…',
  },
  clientInstellingen: {
    title: 'Mijn gegevens',
    subtitle: 'Bekijk en bewerk je persoonlijke gegevens',
    labelKlantnummer: 'Klantnummer (alleen lezen)',
    labelVolledigeNaam: 'Volledige naam',
    labelEmail: 'E-mailadres (alleen lezen)',
    labelTelefoon: 'Telefoonnummer',
    labelStraat: 'Straat',
    labelHuisnummer: 'Huisnummer',
    labelPostcode: 'Postcode',
    labelWoonplaats: 'Woonplaats',
    opslaan: 'Opslaan',
    opslaanSucces: 'Gegevens opgeslagen.',
    opslaanFout: 'Fout bij opslaan: ',
    foutLaden: 'Fout bij laden gegevens: ',
  },
  lesBewerken: {
    title: 'Les bewerken',
    terug: '← Terug',
    editScopeLabel: 'Welke lessen wilt u bewerken?',
    editScopeSingle: 'Alleen deze les',
    editScopeFromHere: 'Deze en volgende lessen',
    editScopeAll: 'Alle lessen in de reeks',
    opslaan: 'Opslaan',
    succesBewerken: 'Les opgeslagen.',
    foutLaden: 'Fout bij laden les: ',
    foutOpslaan: 'Fout bij opslaan: ',
    lesNietGevonden: 'Les niet gevonden.',
    overrideDetachedLabel: 'Ook individueel afgeweken lessen (met een eigen tijd) overschrijven met de nieuwe tijd',
    maxParticipantsGuardError: 'Kan max. deelnemers niet verlagen: {lessen} les(sen) hebben samen {inschrijvingen} actieve inschrijving(en) boven het nieuwe maximum.',
    creditCostWaarschuwingTitel: 'Credit-kosten wijzigen',
    creditCostWaarschuwing: '{count} les(sen) in dit bereik hebben al actieve inschrijvingen. De nieuwe credit-kosten gelden alleen voor toekomstige inschrijvingen; bestaande afschrijvingen wijzigen niet met terugwerkende kracht. Doorgaan?',
  },
  lesAanmaken: {
    titleNieuw: 'Nieuwe les aanmaken',
    terug: '← Terug naar rooster',
    sectionBasic: 'Basisgegevens',
    naamLabel: 'Naam',
    naamPlaceholder: 'Naam van de les…',
    beschrijvingLabel: 'Beschrijving (optioneel)',
    beschrijvingPlaceholder: 'Korte omschrijving…',
    meenemenLabel: 'Wat meenemen (optioneel)',
    meenemenPlaceholder: 'Bijv. handdoek, matje, waterfles',
    locatieLabel: 'Locatie',
    andereLocatie: 'Andere locatie…',
    andereLocatieHint: 'Vul hieronder de gegevens van de tijdelijke locatie in.',
    opslaanAlsVasteLocatie: 'Opslaan als vaste locatie',
    opslaanAlsVasteLocatieConfirm: 'Wil je deze locatie opslaan voor toekomstig gebruik?',
    foutOpslaanLocatie: 'Fout bij opslaan locatie: ',
    valCustomLocationName: 'Vul een naam in voor de locatie.',
    typeLabel: 'Type',
    typeGroepsles: 'Groepsles',
    typePT: 'PT-afspraak',
    typeWorkshop: 'Workshop',
    coachLabel: 'Coach',
    clientLabel: 'Cliënt',
    selecteerClient: 'Selecteer een cliënt…',
    geenClients: 'Geen cliënten beschikbaar (selecteer eerst een coach).',
    valClient: 'Selecteer een cliënt bij een PT-afspraak.',
    sectionDatetime: 'Datum & tijd',
    datumLabel: 'Startdatum',
    tijdLabel: 'Starttijd',
    duurLabel: 'Duur (minuten)',
    duurPlaceholder: '60',
    sectionCapacity: 'Capaciteit & credits',
    maxDeelnemersLabel: 'Max. deelnemers',
    maxPlaceholder: '10',
    annuleringstermijnLabel: 'Annuleringstermijn (uren)',
    annuleringsPlaceholder: '24',
    creditCostLabel: 'Creditkosten',
    creditPlaceholder: '1',
    workshopCreditHint: 'Workshops zijn gratis (0 credits) — dit veld is niet van toepassing.',
    sectionAbonnementen: 'Toegestane abonnementen',
    abonnementenHint: 'Standaard kunnen alle abonnementen zich inschrijven. Selecteer specifieke typen om de toegang te beperken.',
    alleAbonnementen: 'Alle abonnementen',
    geenAbonnementenGevonden: 'Geen abonnementstypes gevonden.',
    sectionHerhaling: 'Herhaling',
    eenmalig: 'Eenmalig',
    terugkerend: 'Terugkerend',
    dagenLabel: 'Dagen van de week',
    einddatumLabel: 'Einddatum reeks',
    oneindigLabel: 'Oneindig (12 weken vooruit)',
    previewLabel: 'Eerste 5 geplande lessen:',
    geenPreview: 'Geen lessen in dit patroon.',
    opslaan: 'Les aanmaken',
    opslaanReeks: 'Reeks aanmaken',
    succesAanmaken: 'Les aangemaakt.',
    succesReeks: 'Lesreeks aangemaakt.',
    foutLaden: 'Fout bij laden: ',
    foutOpslaan: 'Fout bij opslaan: ',
    foutInschrijvenReeks: 'De lessen zijn aangemaakt, maar het inschrijven van de cliënt is mislukt: ',
    valNaam: 'Naam is verplicht.',
    valLocatie: 'Selecteer een locatie.',
    valDuur: 'Duur moet groter zijn dan 0.',
    valMax: 'Max. deelnemers is verplicht.',
    valDagen: 'Selecteer minimaal één dag.',
    valEinddatum: 'Einddatum is verplicht.',
    valInschrijvingenBestaand: 'Er zijn al {aantal} client(s) ingeschreven op {lessen} les(sen). Je kunt alleen een abonnementsrestrictie instellen op lessen zonder actieve inschrijvingen.',
    geenLocaties: 'Geen actieve locaties beschikbaar.',
    geenCoaches: 'Geen coaches beschikbaar.',
    weekdagen: { ma: 'Ma', di: 'Di', wo: 'Wo', do: 'Do', vr: 'Vr', za: 'Za', zo: 'Zo' },
    ptPlusToggle: '1-op-2 PT afspraak (twee cliënten)',
    tweedeClientLabel: 'Tweede cliënt',
    selecteerTweedeClient: 'Selecteer tweede cliënt…',
    sessieDuurLabel: 'Sessieduur',
    minuten: 'minuten',
    ptPlusWarnGeenAbo: 'Deze cliënt heeft geen actief abonnement met PT-plus credits.',
    ptPlusWarnCredits: 'Deze cliënt heeft onvoldoende PT-plus credits.',
    ptPlusWarnDuur: 'Sessieduur ({gekozen} min) wijkt af van het abonnement van deze cliënt ({abo} min).',
    valTweedeClient: 'Selecteer een tweede cliënt bij een 1-op-2 PT afspraak.',
    // Abonnementskeuze + creditaftrek bij coach-directe PT-aanmaak (2026-08-01)
    abonnementLabel: 'Credits afboeken op',
    abonnementTweedeLabel: 'Credits tweede cliënt afboeken op',
    abonnementOnbekend: 'Onbekend abonnement',
    kiesAbonnement: 'Kies een abonnement…',
    creditsResterend: '{aantal} credits over',
    valAbonnementLaden: 'De abonnementen worden nog geladen — probeer het zo opnieuw.',
    valGeenAbo: 'Deze cliënt heeft geen actief PT- of PT-plus-abonnement. Koppel eerst een abonnement, of zet de kosten op 0 credits.',
    valGeenAboTweede: 'De tweede cliënt heeft geen actief PT- of PT-plus-abonnement.',
    valKiesAbo: 'Kies op welk abonnement de credits van de cliënt worden afgeboekt.',
    valKiesAboTweede: 'Kies op welk abonnement de credits van de tweede cliënt worden afgeboekt.',
    valGeenCredits: 'Er zijn niet genoeg credits over op {naam} voor deze afspraak.',
    creditConfirmTitel: 'Niet genoeg credits voor de hele reeks',
    creditConfirmTekst: 'Deze reeks bevat {gevraagd} afspraken en kost {nodig} credits, maar er staan er nog {beschikbaar} op {naam}. Er worden dan {haalbaar} afspraken aangemaakt; de rest vervalt. Doorgaan?',
    creditConfirmKnop: 'Toch aanmaken',
    succesReeksGedeeltelijk: '{aangemaakt} van de {gevraagd} lessen aangemaakt — de credits waren daarna op.',
    foutGeenLessenAangemaakt: 'Er is geen enkele les aangemaakt — controleer het creditsaldo van de cliënt.',
  },
  lesDetail: {
    laden: 'Laden…',
    bewerken: 'Bewerken',
    annuleren: 'Les annuleren',
    cancelFormTitel: 'Les annuleren',
    cancelScopeLabel: 'Welke lessen wilt u annuleren?',
    cancelScopeSingle: 'Alleen deze les',
    cancelScopeFromHere: 'Deze en volgende lessen',
    cancelScopeAll: 'Alle lessen in de reeks',
    cancelRedenLabel: 'Reden (optioneel)',
    cancelRedenPlaceholder: 'Reden voor annulering…',
    cancelBevestigen: 'Ja, annuleren',
    cancelSucces: '{count} les(sen) geannuleerd.',
    cancelFout: 'Fout bij annuleren: ',
    foutLaden: 'Fout bij laden inschrijvingen: ',
    sluiten: 'Sluiten',
    typeGroepsles: 'Groepsles',
    typePT: 'PT-afspraak',
    typeWorkshop: 'Workshop',
    bezetting: 'Bezetting',
    vol: 'VOL',
    ingeschrevenen: 'Ingeschreven',
    wachtlijst: 'Wachtlijst',
    geenIngeschrevenen: 'Geen ingeschrevenen.',
    geenWachtlijst: 'Geen wachtlijst.',
    positie: 'positie',
    uitschrijven: 'Uitschrijven',
    uitschrijvenBevestiging: 'Weet je zeker dat je {naam} wilt uitschrijven?',
    uitschrijvenSucces: '{naam} is uitgeschreven.',
    uitschrijvenSuccesPushFout: '{naam} is uitgeschreven, maar het pushbericht kon niet worden verstuurd. Laat het de cliënt zelf weten.',
    uitschrijvenFout: 'Fout bij uitschrijven: ',
    pushKnop: 'Pushbericht versturen',
    pushFormTitel: 'Pushbericht versturen aan deelnemers',
    pushOntvangersLabel: 'Ontvangers',
    pushOntvangersEnrolled: 'Ingeschreven',
    pushOntvangersWaitlisted: 'Wachtlijst',
    pushOntvangersBoth: 'Beiden (ingeschreven + wachtlijst)',
    pushBerichtLabel: 'Bericht',
    pushBerichtPlaceholder: 'Typ een bericht voor de deelnemers…',
    pushVersturen: 'Verstuur pushbericht',
    pushBerichtVerplicht: 'Bericht is verplicht.',
    pushGeenOntvangers: 'Geen ontvangers in deze groep.',
    pushFoutTokens: 'Fout bij ophalen push tokens: ',
    pushVerzenden: 'Verzenden… {sent} / {total} berichten verstuurd',
    pushSucces: '✓ {sent} pushberichten verstuurd. {skipped} clients hebben geen push token.',
    pushSluiten: 'Sluiten',
    hoverLidmaatschap: 'Type lidmaatschap',
    hoverStartdatum: 'Startdatum',
    hoverGeldigTm: 'Geldig t/m',
    hoverGeenLidmaatschap: 'Geen actief lidmaatschap',
    hoverBekijkProfiel: 'Bekijk profiel →',
    hoverActief: 'Actief',
    hoverBlokkade: '⚠ Blokkade',
    unenrollJa: 'Ja, uitschrijven',
    unenrollNee: 'Nee',
    unenrollPushLabel: 'Pushbericht sturen',
    unenrollDefaultBericht: 'Je bent door {coach} uitgeschreven voor {les} op {datum} om {tijd}.',
    unenrollCoachFallback: 'de coach',
    clientInschrijvenKnop: '+ Client inschrijven',
    inschrijfFormTitel: 'Client inschrijven voor deze les',
    inschrijfClientLabel: 'Client',
    inschrijfClientPlaceholder: 'Selecteer een client…',
    inschrijfBevestigingLabel: 'Bevestiging vereist',
    inschrijfCreditsLabel: 'Credits in rekening brengen',
    inschrijfCreditInfo: 'Creditkosten: {cost} credit(s)',
    inschrijfOpslaan: 'Inschrijven',
    inschrijfSuccesEnrolled: 'Client ingeschreven.',
    inschrijfSuccesPending: 'Inschrijving aangemaakt, wacht op bevestiging van client.',
    inschrijfSuccesWaitlisted: 'Client op wachtlijst geplaatst.',
    inschrijfFout: 'Fout bij inschrijven: ',
    inschrijfGeenClients: 'Geen clients beschikbaar.',
    inschrijfLaden: 'Clients laden…',
    inschrijfPushEnrolled: 'Je bent ingeschreven voor {les} op {datum} om {tijd} door {coach}.',
    inschrijfPushPending: 'Je bent uitgenodigd voor {les} op {datum} om {tijd}. Bevestig je deelname in de app.',
    inschrijfPushWaitlisted: 'Je staat op de wachtlijst voor {les} op {datum} om {tijd}.',
    pendingTitel: 'Wacht op bevestiging',
    geenPending: 'Geen openstaande bevestigingen.',
    pendingAnnuleren: 'Annuleren',
    pendingAnnulerenFout: 'Fout bij annuleren: ',
    pendingAnnulerenSucces: '{naam} verwijderd uit uitnodigingen.',
  },
  clientRoosterUitnodigingen: {
    titel: 'Openstaande uitnodigingen',
    bevestigen: 'Bevestigen',
    afwijzen: 'Afwijzen',
    geenOpenstaand: 'Geen openstaande uitnodigingen.',
    bevestigdSucces: 'Deelname bevestigd!',
    afgewezenSucces: 'Uitnodiging afgewezen.',
    foutBevestigen: 'Fout bij bevestigen: ',
    foutAfwijzen: 'Fout bij afwijzen: ',
    foutLaden: 'Fout bij laden uitnodigingen: ',
  },
  communication: {
    title: 'Communicatie',
    loading: 'Laden…',
    empty: 'Nog geen communicatie gelogd.',
    loadMore: 'Toon meer',
    colDatum: 'Datum',
    colType: 'Type',
    colOnderwerp: 'Onderwerp',
    colBericht: 'Bericht',
    types: {
      message: 'In-app bericht',
      push: 'Pushbericht',
      reminder: 'Betalingsherinnering',
      final_notice: 'Laatste aanmaning',
      collections: 'Incasso-overdracht',
      agreement_sent: 'Overeenkomst',
      agreement_signed: 'Overeenkomst ondertekend',
      agreement_rejected: 'Overeenkomst',
      agreement_revoked: 'Overeenkomst',
      agreement_reminder: 'Overeenkomst herinnering',
      prospect_reminder: 'Prospect herinnering',
      welcome: 'Welkomstmail',
      cancellation_confirmation: 'Opzeggingsbevestiging',
    },
    geplandLabel: 'Gepland',
    stuurNuKnop: 'Stuur nu',
    stuurProspectHerinnering: 'Stuur herinnering nu',
    prospectReminderVerstuurd: 'Prospect herinnering verstuurd.',
    prospectReminderFout: 'Fout bij versturen herinnering: ',
    channels: {
      in_app: 'In-app',
      push: 'Push',
      system: 'Systeem',
    },
  },
  voeding: {
    titel: 'Voeding & Kcal',
    instellen: 'Kcal instellen / aanpassen',
    dagKcal: 'Dagelijks maximum',
    eiwitten: 'Eiwitten doel',
    koolhydraten: 'Koolhydraten doel',
    vetten: 'Vetten doel',
    ingesteldOp: 'Ingesteld op:',
    geenToewijzing: 'Nog geen kcal-toewijzing ingesteld.',
    modalTitel: 'Kcal instellen / aanpassen',
    labelDagKcal: 'Dagelijks kcal maximum',
    labelEiwitten: 'Eiwitten doel (gram)',
    labelKoolhydraten: 'Koolhydraten doel (gram)',
    labelVetten: 'Vetten doel (gram)',
    optioneel: 'optioneel',
    opslaan: 'Opslaan',
    annuleren: 'Annuleren',
    valDagKcal: 'Voer een geldig kcal-getal in.',
    foutOpslaan: 'Fout bij opslaan: ',
  },
  recipes: {
    title: 'Recepten',
    subtitle: 'Beheer de receptenbibliotheek',
    nieuw: '+ Nieuw recept',
    zoekPlaceholder: 'Zoeken op naam…',
    alleEetmomenten: 'Alle eetmomenten',
    toonInactief: 'Toon inactief',
    colNaam: 'Naam',
    colEetmoment: 'Eetmoment',
    colKcal: 'Kcal',
    colEiwitten: 'Eiwitten',
    colKoolhydraten: 'Koolhydraten',
    colVetten: 'Vetten',
    colAvondetenComponent: 'Avondeten component',
    colStatus: 'Status',
    colActies: 'Acties',
    badgeActief: 'Actief',
    badgeInactief: 'Inactief',
    bewerken: 'Bewerken',
    deactiveren: 'Deactiveren',
    activeren: 'Activeren',
    geenRecepten: 'Geen recepten gevonden.',
    modalTitelNieuw: 'Nieuw recept',
    modalTitelBewerken: 'Recept bewerken',
    labelNaam: 'Naam',
    labelEetmoment: 'Eetmomenten',
    labelKcal: 'Kcal',
    labelEiwitten: 'Eiwitten (gram)',
    labelKoolhydraten: 'Koolhydraten (gram)',
    labelVetten: 'Vetten (gram)',
    labelBeschrijving: 'Beschrijving (optioneel)',
    labelAvondetenComponent: 'Is avondeten component',
    labelComponentType: 'Component type',
    kiesComponentType: 'Kies een component type…',
    optioneel: 'optioneel',
    opslaan: 'Opslaan',
    annuleren: 'Annuleren',
    deactiverenTitel: 'Recept deactiveren',
    deactiverenTekst: 'Weet je zeker dat je dit recept wilt deactiveren? Het recept verdwijnt uit de keuzelijsten maar blijft zichtbaar in bestaande schema\'s.',
    deactiverenBevestigen: 'Ja, deactiveren',
    foutLaden: 'Fout bij laden recepten: ',
    foutOpslaan: 'Fout bij opslaan recept: ',
    valNaam: 'Naam is verplicht.',
    valEetmoment: 'Selecteer minimaal 1 eetmoment.',
    valKcal: 'Voer een geldig kcal-getal in.',
    badgeExtended: 'uitgebreid',
    colType: 'Type',
    recipeTypeLabel: 'Type recept',
    recipeTypeBasis: 'Basis',
    recipeTypeUitgebreid: 'Uitgebreid',
    labelVideoUrl: 'Video-URL',
    labelPhotos: "Foto's",
    addPhoto: 'Foto toevoegen',
    uploadingPhoto: 'Foto uploaden…',
    coverPhotoBadge: 'Omslagfoto',
    removePhoto: 'Foto verwijderen',
    movePhotoUp: 'Naar voren',
    movePhotoDown: 'Naar achteren',
    noPhotos: "Nog geen foto's toegevoegd.",
    photoUploadError: 'Foto uploaden is mislukt.',
    labelPrepTime: 'Voorbereidingstijd (min)',
    labelCookTime: 'Bereidingstijd (min)',
    labelDifficulty: 'Moeilijkheidsgraad',
    kiesDifficulty: 'Kies een moeilijkheidsgraad…',
    difficultyMakkelijk: 'Makkelijk',
    difficultyGemiddeld: 'Gemiddeld',
    difficultyMoeilijk: 'Moeilijk',
    labelServings: 'Aantal personen',
    labelIngredients: 'Ingrediënten',
    addIngredient: '+ Ingrediënt',
    ingredientNamePlaceholder: 'Naam (bijv. Rijst)',
    ingredientAmountPlaceholder: 'Hoeveelheid',
    ingredientUnitPlaceholder: 'Eenheid (bijv. g)',
    labelSteps: 'Bereidingsstappen',
    addStep: '+ Stap',
    stepTitlePlaceholder: 'Titel (optioneel)',
    stepInstructionPlaceholder: 'Instructie *',
    stepDurationPlaceholder: 'Tijdsduur (seconden, optioneel)',
    extendedRequiresStep: 'Een uitgebreid recept vereist minstens 1 bereidingsstap met instructie.',
    removeItem: 'Verwijderen',
    terug: '← Terug naar recepten',
    dragHandle: 'Sleep om te herordenen',
    verlatenTitel: 'Pagina verlaten?',
    verlatenTekst: 'Je hebt niet-opgeslagen wijzigingen. Als je nu teruggaat, gaan deze verloren.',
    verlatenBevestigen: 'Ja, verlaten zonder opslaan',

    // Cliënt-voedingsmodule (VoedingPage/WeekschemaPage/RecipeDetailPage) —
    // zelfde backend/RPC's en tekst als de app (DagschemaScreen.js/
    // WeekschemaScreen.js/RecipeDetailScreen.js), zie BRIEFING.md hfst. 7.
    mealBreakfast: 'Ontbijt',
    mealSnackMorning: 'Tussendoor 1',
    mealLunch: 'Lunch',
    mealSnackAfternoon: 'Tussendoor 2',
    mealDinner: 'Avondeten',
    mealEveningSnack: 'Avondsnack',
    dinnerProteinLabel: 'Vlees / Vis',
    dinnerCarbsLabel: 'Koolhydraten',
    dinnerVegetablesLabel: 'Groente',
    dagKort: { 0: 'Zo', 1: 'Ma', 2: 'Di', 3: 'Wo', 4: 'Do', 5: 'Vr', 6: 'Za' },
    // Volledige, kleine-letter dagnaam voor "Totaal {dag}"/"Kopieer {dag}…" —
    // de dagselector/startdag-instelling blijft bewust op dagKort (afkortingen).
    dagVol: { 0: 'zondag', 1: 'maandag', 2: 'dinsdag', 3: 'woensdag', 4: 'donderdag', 5: 'vrijdag', 6: 'zaterdag' },

    voedingTitle: 'Voeding',
    voedingSubtitle: 'Jouw eetmomenten van vandaag',
    kcalUsed: 'Verbruikt',
    kcalGoal: 'Doel',
    kcalRemaining: 'Resterend',
    kcalPctGoal: '{pct}% van dagdoel',
    mealsSectionTitle: 'Eetmomenten',
    notYetChosen: 'Nog niet gekozen',
    kcalLeftOver: '{kcal} kcal over',
    viewWeekschema: 'Weekschema bekijken & aanpassen',
    removeMealAction: 'Verwijderen',
    removeMealTitel: 'Maaltijdkeuze verwijderen?',
    removeMealTekst: 'Weet je zeker dat je deze keuze wilt verwijderen?',
    currentChoice: 'Huidige keuze',
    chooseParts: 'Kies alle onderdelen',
    allPartsRequired: 'Selecteer een optie voor vlees/vis, koolhydraten en groente.',
    dinnerHintText: 'Kies één optie uit elk onderdeel. Het totaal is altijd 450 kcal.',
    allChosen: 'Alle 3 onderdelen gekozen · Totaal 450 kcal',
    saveDinner: 'Avondeten opslaan',
    tooMuchKcal: 'Te veel kcal voor dit moment',
    noRecipesAvailable: 'Geen recepten beschikbaar',
    noRecipesSub: 'De coach heeft nog geen recepten toegevoegd voor dit eetmoment.',
    membershipRequiredTitel: 'Actief abonnement vereist',
    membershipRequiredTekst: 'Je hebt nog geen actief abonnement. Neem contact op met je coach om de voedingsmodule te gebruiken.',
    kiezenAction: 'Kiezen',
    foutOpslaanKeuze: 'Fout bij opslaan keuze: ',
    notFilledIn: 'Niet ingevuld',
    todayLabel: 'Vandaag',
    yesterdayLabel: 'Gisteren',
    previousDay: 'Vorige dag',
    nextDay: 'Volgende dag',
    openCalendar: 'Kalender openen',
    calendarTitle: 'Kalender',
    calendarPrevMonth: 'Vorige maand',
    calendarNextMonth: 'Volgende maand',

    weekschemaTitle: 'Weekschema',
    settingsTitle: 'Schema instellingen',
    recurring: 'Herhalend',
    recurringDesc: 'Elke week hetzelfde',
    oneTime: 'Eenmalig',
    oneTimeDesc: 'Alleen deze week',
    startDayLabel: 'Startdag van de week',
    saveSettings: 'Instellingen opslaan',
    savedTitel: '✓ Opgeslagen',
    savedRecurring: 'Je weekschema herhaalt zich elke week.',
    savedOneTime: 'Je weekschema geldt voor deze week. Je ontvangt een herinnering om het volgende week opnieuw in te stellen.',
    daySection: 'Dag instellen',
    notSet: 'Niet ingesteld',
    totalLabel: 'Totaal {day}',
    copyBtn: 'Kopieer {day} naar alle andere dagen',
    copyTitel: 'Kopiëren',
    copyMsg: 'Maaltijden van {day} kopiëren naar alle andere dagen?',
    copyAction: 'Kopiëren',
    copiedTitel: '✓ Gekopieerd',
    copiedMsg: 'Maaltijden zijn gekopieerd naar alle andere dagen.',
    conflictTitel: 'Er staan al voedingskeuzes voor deze week',
    conflictTekst: 'Voor {count} dag(en) deze week zijn al voedingskeuzes vastgelegd. Wat wil je doen?',
    conflictOverwrite: 'Overschrijf de {count} al ingevulde dagen met dit weekschema',
    conflictKeepExisting: 'Laat de al ingevulde dagen ongewijzigd, pas de rest van de week toe',
    weekschemaKonNietWordenAangemaakt: 'Weekschema kon niet worden aangemaakt.',

    recipeDetailTerug: '← Terug',
    prepTime: '{min} min voorbereiding',
    cookTime: '{min} min bereiding',
    servings: '{count} personen',
    macrosLabel: 'Voedingswaarden',
    caloriesLabel: 'Calorieën',
    proteinLabel: 'Eiwitten',
    carbsLabel: 'Koolhydraten',
    fatLabel: 'Vetten',
    ingredientsTitle: 'Ingrediënten',
    stepsTitle: 'Bereiding',
    chooseAction: 'Kiezen voor vandaag',
    startCooking: 'Start met koken',
    noRecipes: 'Geen recepten beschikbaar.',
    stepProgress: 'Stap {current} van {total}',
    stepPrev: '← Vorige',
    stepNext: 'Volgende →',
    stepDone: '✓ Klaar met koken',
    timerStart: 'Zet timer aan',
    timerStop: 'Pauzeer timer',
    fotoVolledigWeergaveSluiten: 'Sluiten',
  },
  abonnementen: {
    title: 'Abonnementen',
    subtitle: 'Beheer abonnementstypes en staffels',
    beheerLink: 'Beheer abonnementen',
    sectionTitel: 'Abonnementen / pakketten',
    nieuwType: '+ Nieuw abonnementstype',
    geenAbonnementen: 'Nog geen abonnementstypes aangemaakt.',
    toonInactief: 'Toon inactief',
    colNaam: 'Naam',
    colCredits: 'Credits/periode',
    colStatus: 'Status',
    colActies: 'Acties',
    badgeActief: 'Actief',
    badgeInactief: 'Inactief',
    deactiveren: 'Deactiveren',
    activeren: 'Activeren',
    typeModalTitelNieuw: 'Nieuw abonnementstype',
    typeModalTitelBewerken: 'Abonnementstype bewerken',
    labelNaam: 'Naam',
    labelCredits: 'Credits per periode',
    labelBtw: 'BTW-percentage',
    btwOptie9: '9%',
    btwOptie21: '21%',
    labelActief: 'Actief',
    opslaan: 'Opslaan',
    annuleren: 'Annuleren',
    foutLaden: 'Fout bij laden abonnementen: ',
    foutOpslaan: 'Fout bij opslaan: ',
    foutDeactiveren: 'Fout bij deactiveren: ',
    foutActieveKoppelingen: 'Dit type kan niet worden verwijderd omdat er nog actieve abonnementen aan gekoppeld zijn.',
    validatieNaam: 'Naam is verplicht.',
    validatieCredits: 'Credits per periode is verplicht.',
    labelOvereenkomst: 'Overeenkomsttekst (optioneel)',
    overeenkomstHint: 'Template voor digitale overeenkomst. Gebruik variabelen om gegevens automatisch in te vullen:',
    overeenkomstPlaceholder: 'Typ hier de overeenkomsttekst. Gebruik [naam], [abonnement], [prijs], [looptijd], [datum] en [bedrijfsnaam] als variabelen.',
    staffelsTitel: 'Staffels',
    staffelToevoegen: '+ Staffel toevoegen',
    staffelModalTitel: 'Staffel toevoegen',
    staffelModalBewerken: 'Staffel bewerken',
    labelDurationMonths: 'Looptijd',
    labelPricePerPeriod: 'Prijs per periode excl. BTW (€)',
    inclBtwPreview: 'Incl. BTW:',
    labelStaffelActief: 'Actief',
    labelPromoLabel: 'Promotielabel (optioneel)',
    promoLabelPlaceholder: 'bv. 1 maand gratis',
    promoLabelHint: 'Wordt getoond als badge op de overeenkomstpagina.',
    colPromo: 'Promo',
    staffelOpslaan: 'Opslaan',
    staffelAnnuleren: 'Annuleren',
    staffelFoutOpslaan: 'Fout bij opslaan staffel: ',
    staffelFoutLaden: 'Fout bij laden staffels: ',
    staffelAlBestaat: 'Er bestaat al een staffel voor deze looptijd.',
    validatiePrijs: 'Prijs is verplicht.',
    validatieDuur: 'Kies een looptijd.',
    duur1: '1 maand',
    duur3: '3 maanden',
    duur6: '6 maanden',
    duur12: '12 maanden',
    geenStaffels: 'Nog geen staffels. Voeg een staffel toe om prijzen in te stellen.',
    colStaffelDuur: 'Looptijd',
    colStaffelPrijs: 'Prijs excl. BTW',
    colStaffelPrijsIncl: 'Prijs incl. BTW',
    colStaffelStatus: 'Status',
    colStaffelActies: 'Acties',
    staffelDeactiveren: 'Deactiveren',
    staffelActiveren: 'Activeren',
    kiesLooptijd: 'Kies looptijd…',
    labelDescription: 'Omschrijving (optioneel)',
    descriptionPlaceholder: 'Korte omschrijving van dit abonnementstype…',
    labelPricePerMonth: 'Prijs per maand (€)',
    labelPricePerPeriod2: 'Totaal per periode (€)',
    labelVatRate: 'BTW-percentage',
    btwOptie0: '0%',
    labelAvailableFrom: 'Beschikbaar vanaf',
    labelAvailableUntil: 'Beschikbaar t/m',
    labelPaymentFrequency: 'Betaalfrequentie',
    payFreqMonth: 'Alleen maandbetaling',
    payFreqPeriod: 'Alleen periodebetaling (eenmalig)',
    payFreqBoth: 'Beide toegestaan (client kiest)',
    labelPriceExclBtw: 'Prijs excl. BTW',
    labelPriceInclBtw: 'Prijs incl. BTW',
    warnVerstrekenStaffel: 'Let op: de einddatum van beschikbaarheid is verstreken. Bestaande contracten blijven geldig.',
    warnVerstrekenStaffelModal: 'Let op: de einddatum ligt in het verleden. Deze staffel is niet meer kiesbaar voor nieuwe lidmaatschappen. Je kunt nog steeds opslaan; bestaande contracten blijven geldig.',
    verstrekenTooltip: 'Deze staffel is verlopen en niet meer kiesbaar voor nieuwe lidmaatschappen. Bestaande contracten blijven geldig.',
    validatieLooptijdMin: 'Looptijd moet minimaal 1 maand zijn.',
    validatiePricePerMonth: 'Prijs per maand is verplicht.',
    inklappen: 'Inklappen',
    uitklappen: 'Uitklappen',
    btwLabel: 'BTW',
    colTotaal: 'Totaal',
    colExclBtw: 'Excl. BTW',
    colBetaalfreq: 'Betaalfreq.',
    colKorting: 'Korting',
    colBeschikbaar: 'Beschikbaar',
    altijdBeschikbaar: 'Altijd',
    perMaand: '/mnd',
    verstrekenLabel: 'VERSTREKEN',
    labelPeriodDiscountPct: 'Korting bij periodebetaling (%)',
    periodDiscountHint: '0 = geen korting. Alleen van toepassing bij periode- of gecombineerde betaling.',
    labelSessionType: 'Sessietype',
    sessionTypePt: '1-op-1 Personal Training',
    sessionTypePtPlus: '1-op-2 Personal Training',
    sessionTypeSmallGroup: 'Small Group Training',
    labelPtSessionsPerWeek: 'Aantal PT-sessies per week',
    labelPtPlusSessionsPerWeek: 'Aantal PT-plus-sessies per week',
    labelSmallGroupSessionsPerWeek: 'Aantal Small Group-sessies per week',
    labelSessionDuration: 'Sessieduur',
    creditsPerMaandLabel: 'credits per maand',
    validatieSessies: 'Vul het aantal sessies per week in (minimaal 1).',
    validatieSessieDuur: 'Kies een sessieduur (30 of 60 minuten).',
    colSessiesPerWeek: 'Sessies/week',
    labelClientSelectable: 'Zichtbaar voor client',
    clientSelectableHint: 'Uitvinken = alleen coach kan dit abonnement toewijzen (bv. bonusabonnement)',
    labelIsRecommended: 'Markeer als aanbevolen',
    isRecommendedHint: 'Toont een groene "Aanbevolen"-badge op de kaart in de overeenkomstpagina (stap 1)',
    sectionBonussen: 'Bonus bij afsluiten',
    bonusGratisLabel: 'Automatisch inbegrepen bij afsluiten',
    bonusBetaaldLabel: 'Optioneel toe te voegen bij afsluiten',
    bonusToevoegen: '+ Bonus toevoegen',
    bonusVerwijderen: 'Verwijderen',
    bonusType: 'Bonusabonnement',
    bonusPrijs: 'Prijsoverride (€)',
    bonusPrijsHint: 'Leeg = staffelprijs, 0 = gratis',
    bonusGeenTypes: 'Geen andere abonnementstypes beschikbaar.',
    bonusFoutLaden: 'Fout bij laden bonussen: ',
    bonusFoutOpslaan: 'Fout bij opslaan bonus: ',
    bonusKiesType: 'Kies abonnementstype…',
    sectionPt: '1-op-1 Personal Training',
    sectionPtPlus: '1-op-2 Personal Training',
    sectionSmallGroup: 'Small Group Training',
    sectionGeenTypes: 'Nog geen abonnementen voor dit type.',
    sectionNieuwVoorType: '+ Nieuw abonnementstype',
    sectionPtHint: 'Reguliere 1-op-1 PT-sessies',
    sectionPtPlusHint: 'Twee clients trainen samen met één coach',
    sectionSmallGroupHint: 'Groepstrainingen voor kleine groepen',
  },
  coachInstellingen: {
    title: 'Instellingen',
    subtitle: 'Jouw persoonlijke agenda-koppeling',
    sectionCalFeed: 'Google Agenda koppeling',
    intro: 'Abonneer op jouw persoonlijke agenda-feed en zie al je lessen en PT-afspraken direct in Google Agenda.',
    urlLabel: 'Jouw agenda-URL',
    kopierenKnop: 'Kopieer',
    gekopieerd: '✓ Gekopieerd!',
    geenToken: 'Nog geen agenda-URL gegenereerd.',
    generaterenKnop: 'Agenda-URL genereren',
    generaterenBezig: 'Genereren…',
    vernieuwenKnop: 'Link vernieuwen',
    vernieuwenWaarschuwing: 'Weet je zeker dat je de link wilt vernieuwen? Je bestaande Google Agenda-abonnement stopt dan — je moet de nieuwe URL opnieuw toevoegen.',
    vernieuwenBevestigen: 'Ja, vernieuwen',
    vernieuwenAnnuleren: 'Annuleren',
    instructieTitel: 'Zo voeg je de feed toe aan Google Agenda:',
    stap1: '1. Ga naar Google Agenda op je computer (calendar.google.com)',
    stap2: '2. Klik links op het + naast "Andere agenda\'s"',
    stap3: '3. Kies "Via URL"',
    stap4: '4. Plak de bovenstaande URL en klik op "Agenda toevoegen"',
    stap5: '5. Google Agenda vernieuwt de feed automatisch (elke paar uur)',
    foutLaden: 'Fout bij ophalen agenda-URL: ',
    foutGenereren: 'Fout bij genereren agenda-URL: ',
    foutKopieren: 'Kopiëren naar het klembord is mislukt. Selecteer de URL hierboven en kopieer hem handmatig.',
  },
  pushCat: {
    title: 'Meldingen',
    introCoach: 'Bepaal hier welke pushmeldingen je van de app ontvangt.',
    introClient: 'Bepaal hier welke pushmeldingen je van de app ontvangt.',
    alwaysOn: 'Bepaalde belangrijke meldingen (account, betalingen en wettelijk verplichte meldingen) worden altijd verstuurd, ongeacht deze instellingen.',
    foutLaden: 'Fout bij ophalen instellingen: ',
    foutOpslaan: 'Instelling kon niet worden opgeslagen: ',
    lessonsScheduleLabel: 'Groepslessen',
    lessonsScheduleDesc: 'Wachtlijstpromoties, gewijzigde of geannuleerde lessen en herinschrijvingen.',
    ptAppointmentsLabel: 'PT-afspraken',
    ptAppointmentsDesc: 'Nieuwe, bevestigde, afgewezen of gewijzigde PT-afspraken en -aanvragen.',
    billingLabel: 'Facturatie',
    billingDesc: 'Aanmaningen en herinneringen over openstaande facturen en je prolongatie.',
    agreementsLabel: 'Overeenkomsten',
    agreementsDesc: 'Uitnodigingen om een overeenkomst te ondertekenen en herinneringen daaraan.',
    coachMessagesLabel: 'Berichten van je coach',
    coachMessagesDesc: 'Persoonlijke en motiverende berichten die je coach je stuurt.',
    clientActivityLabel: 'Cliëntactiviteit',
    clientActivityDesc: 'Meldingen over activiteit van je cliënten (gereserveerd voor toekomstige coach-notificaties).',
  },
  wachtwoordWijzigen: {
    title: 'Wachtwoord wijzigen',
    intro: 'Kies een nieuw wachtwoord voor je account.',
    labelNieuw: 'Nieuw wachtwoord',
    placeholderNieuw: 'Min. 6 tekens',
    labelHerhaal: 'Herhaal nieuw wachtwoord',
    opslaanKnop: 'Wachtwoord opslaan',
    succes: 'Wachtwoord gewijzigd.',
    fout: 'Fout bij wijzigen wachtwoord: ',
    foutTeKort: 'Het nieuwe wachtwoord moet minimaal 6 tekens bevatten.',
    foutMismatch: 'De wachtwoorden komen niet overeen.',
  },
  wachtwoordReset: {
    laden: 'Bezig met controleren van je link...',
    titel: 'Nieuw wachtwoord instellen',
    intro: 'Kies hieronder een nieuw wachtwoord voor je account.',
    labelNieuw: 'Nieuw wachtwoord',
    placeholderNieuw: 'Min. 6 tekens',
    labelHerhaal: 'Herhaal nieuw wachtwoord',
    opslaanKnop: 'Wachtwoord opslaan',
    foutTeKort: 'Het nieuwe wachtwoord moet minimaal 6 tekens bevatten.',
    foutMismatch: 'De wachtwoorden komen niet overeen.',
    fout: 'Fout bij opslaan wachtwoord: ',
    succesTitel: 'Wachtwoord gewijzigd',
    succesUitleg: 'Je wachtwoord is succesvol gewijzigd. Je wordt doorgestuurd naar de inlogpagina...',
    succesNaarInloggen: 'Ga direct naar inloggen',
    ongeldigTitel: 'Link verlopen of ongeldig',
    ongeldigUitleg: 'Deze link om je wachtwoord opnieuw in te stellen is verlopen of al gebruikt. Vraag in de app via "Wachtwoord vergeten" een nieuwe link aan.',
    naarInloggen: 'Naar inloggen',
  },
  opzegMailInstelling: {
    title: 'E-mail bij opzegging',
    intro: 'Bepaal of je een e-mail ontvangt wanneer een aan jou gekoppelde cliënt een abonnement opzegt.',
    label: 'Ontvang een e-mail bij opzegging van een gekoppelde cliënt',
    foutLaden: 'Fout bij ophalen instelling: ',
    foutOpslaan: 'Instelling kon niet worden opgeslagen: ',
  },
  privateAgendaKoppeling: {
    title: 'Privé-agenda koppelen',
    intro: 'Koppel je privé-agenda (Google, Outlook of iCloud) zodat bij het inplannen van een afspraak automatisch wordt gecheckt op conflicten met je privéafspraken.',
    urlLabel: 'ICS-URL van je privé-agenda',
    instructieTitel: 'Zo vind je de geheime iCal-URL:',
    instructieGoogle: 'Google Agenda: Instellingen → jouw agenda → "Geheime adres in iCal-indeling"',
    instructieOutlook: 'Outlook: Instellingen → Agenda → Gedeelde agenda\'s → "ICS-koppeling publiceren"',
    instructieIcloud: 'iCloud: iCloud.com Agenda → Deel agenda → "Openbare agenda" → kopieer de webcal-link (vervang webcal:// door https://)',
    labelShareDetails: 'Details van privé-afspraken delen',
    hintShareDetails: 'Indien aan: wie voor jou inplant ziet de titel van een conflicterende privé-afspraak. Indien uit: alleen "Bezet (privé-agenda)" zonder details.',
    laatsteSyncLabel: 'Laatst gesynchroniseerd:',
    syncStatusSuccess: 'gelukt',
    syncStatusError: 'mislukt',
    syncNuKnop: 'Nu synchroniseren',
    syncBezig: 'Synchroniseren…',
    syncGelukt: 'Privé-agenda gesynchroniseerd.',
    foutSync: 'Fout bij synchroniseren: ',
    opslaanKnop: 'Opslaan',
    opgeslagen: 'Instellingen opgeslagen.',
    foutOpslaan: 'Fout bij opslaan: ',
    foutLaden: 'Fout bij ophalen instellingen: ',
    foutLegeUrl: 'Vul een ICS-URL in.',
  },
  conflicten: {
    titel: 'Roosterconflict gedetecteerd',
    beschrijving: 'De volgende afspraken/lessen van de coach overlappen met dit tijdvak:',
    typeGroepsles: 'Groepsles',
    typePT: 'PT-afspraak',
    bevestigenKnop: 'Toch opslaan',
    annulerenKnop: 'Annuleren',
    checkFout: 'Fout bij conflictcontrole: ',
    typePrivateAgenda: 'Privé-agenda',
    privateAgendaBusy: 'Bezet (privé-agenda)',
    acceptBevestigenKnop: 'Toch accepteren',
  },
  beschikbaarheid: {
    titel: 'Beschikbaarheid',
    laden: 'Beschikbaarheid laden...',
    foutLaden: 'Fout bij ophalen beschikbaarheid: ',
    legeSlot: 'Vrij',
    bezetRooster: 'Bezet (rooster)',
    bezetPrive: 'Bezet (privé-agenda)',
    klikOmTeKiezen: 'Klik op een vrij tijdslot om te kiezen',
    gekozenTijdstip: 'Gekozen tijdstip',
    gekozenConflict: 'Let op: het gekozen tijdstip overlapt met bovenstaande bezetting.',
    geenVrijeSlotsVandaag: 'Geen vrije tijdsloten op deze dag.',
    eerstvolgendeBeschikbaarheid: 'Eerstvolgende beschikbaarheid: ',
    vorigePeriode: '←',
    volgendePeriode: '→',
  },
  coachPush: {
    nieuweLes: 'Nieuwe les voor jou ingepland',
    nieuweLesBody: '{naam} op {datum}',
    lesGewijzigd: 'Les gewijzigd',
    lesGewijzigdBody: '{naam} op {datum} is bijgewerkt.',
    reeksGewijzigd: 'Reeks gewijzigd',
    reeksGewijzigdBody: 'Reeks \'{naam}\' is bijgewerkt.',
    lesGeannuleerd: 'Les geannuleerd',
    lesGeannuleerdBody: '{naam} op {datum} is geannuleerd.',
  },
  lesFormulier: {
    selecteerLocatie: '— selecteer locatie —',
    selecteerCoach: '— selecteer coach —',
    jij: ' (jij)',
    begindatumReeks: 'Begindatum reeks',
    starttijdLabel: 'Starttijd {dag}',
    wijzigen: 'wijzigen',
    markAsTrial: 'Dit is een proefsessie',
  },
  admin: {
    noLocations: 'Geen locaties gevonden',
    addLocation: 'Locatie toevoegen',
    editLocation: 'Locatie bewerken',
    newLocation: 'Nieuwe locatie',
    locationName: 'Naam',
    locationNamePlaceholder: 'Bijv. Sporthal Noord',
    locationStreet: 'Straat',
    locationStreetPlaceholder: 'Bijv. Sportlaan',
    locationHouseNumber: 'Huisnummer',
    locationHouseNumberPlaceholder: 'Bijv. 1',
    locationPostalCode: 'Postcode',
    locationPostalCodePlaceholder: 'Bijv. 1234 AB',
    locationCity: 'Woonplaats',
    locationCityPlaceholder: 'Bijv. Amsterdam',
    inactive: 'Inactief',
    deactivate: 'Deactiveren',
    activate: 'Activeren',
    locationToggleConfirm: '{action} \'{name}\'?',
    locationToggleTitel: 'Locatie bijwerken',
    showInactive: 'Toon inactieve',
    hideInactive: 'Verberg inactieve',
    annuleren: 'Annuleren',
    opslaan: 'Opslaan',
  },
  factuurteksten: {
    title: 'Factuurteksten',
    subtitle: 'Beheer alle teksten die op facturen en herinneringen verschijnen',
    algemeenTitel: 'Algemene factuurvoetnoot',
    labelAlgemeneVoetnoot: 'Algemene factuurvoetnoot',
    hintAlgemeen: 'Deze tekst verschijnt onderaan alle facturen, ongeacht de status.',
    voetnootTitel: 'Factuurvoetnoot per status',
    labelFooterDraft: 'Voetnoot bij concept',
    labelFooterSent: 'Voetnoot bij verzonden',
    labelFooterReminded: 'Voetnoot bij herinnerd',
    labelFooterFinalNotice: 'Voetnoot bij laatste aanmaning',
    labelFooterCollections: 'Voetnoot bij incasso',
    hintVoetnoot: 'Deze tekst verschijnt onderaan de factuur bij de bijbehorende status.',
    herinneringTitel: 'Herinnerings- en aanmaningsteksten',
    labelReminderPdfText: 'Herinneringstekst PDF',
    labelFinalNoticePdfText: 'Aanmaningstekst PDF',
    hintHerinnering: 'Deze tekst verschijnt in de PDF van de herinnering of aanmaning.',
    opslaan: 'Opslaan',
    opgeslagen: 'Factuurteksten opgeslagen.',
    foutLaden: 'Fout bij laden factuurteksten: ',
    foutOpslaan: 'Fout bij opslaan factuurteksten: ',
  },
  emailteksten: {
    title: 'E-mailteksten',
    subtitle: 'Beheer de teksten en templates die in automatische e-mails worden gebruikt',
    tekstveldenTitel: 'Tekstvelden',
    tekstveldenSubtitel: 'Stel de standaard teksten in per e-mailtype. Deze velden zijn beschikbaar voor admin_coach en superadmin.',
    variabelenTitel: 'Beschikbare variabelen',
    variabelenLegenda: '[naam], [bedrag], [factuurnummer], [betaaldatum], [bedrijfsnaam] — deze worden automatisch vervangen door de echte waarden.',
    labelAanhef: 'Aanhef (gedeeld)',
    hintAanhef: 'Gebruikt in alle e-mailtypes.',
    introTitel: 'Introductietekst per e-mailtype',
    labelIntroFactuur: 'Introductie — Factuur',
    labelIntroHerinnering: 'Introductie — Herinnering',
    labelIntroAanmaning: 'Introductie — Aanmaning',
    labelIntroIncasso: 'Introductie — Incasso',
    labelSlotgroet: 'Slotgroet (gedeeld)',
    hintSlotgroet: 'Gebruikt in alle e-mailtypes.',
    htmlTitel: 'HTML-templates (superadmin)',
    htmlSubtitel: 'Overschrijf de volledige e-mailtemplate per type. Alleen zichtbaar voor superadmin.',
    waarschuwingTitel: 'Let op',
    waarschuwingTekst: 'Dit overschrijft de volledige e-mailtemplate. Gebruik [naam], [bedrag], [factuurnummer], [betaaldatum], [bedrijfsnaam] als variabelen.',
    labelHtmlFactuur: 'HTML template — Factuur',
    labelHtmlHerinnering: 'HTML template — Herinnering',
    labelHtmlAanmaning: 'HTML template — Aanmaning',
    labelHtmlIncasso: 'HTML template — Incasso',
    opslaan: 'Opslaan',
    opgeslagen: 'Tekst opgeslagen.',
    opslagenTeksten: 'Tekstvelden opgeslagen.',
    opgeslagenHtml: 'HTML-templates opgeslagen.',
    foutLaden: 'Fout bij laden e-mailteksten: ',
    foutOpslaanTeksten: 'Fout bij opslaan tekstvelden: ',
    foutOpslaanHtml: 'Fout bij opslaan HTML-templates: ',
    tabAlgemeen: 'Algemeen',
    tabAlgemeenSubtitel: 'Aanhef en slotgroet worden in alle e-mailtypes gebruikt.',
    tabMailtypeSubtitel: 'Stel de introductietekst in voor dit e-mailtype.',
    beschikbareVariabelen: 'Beschikbare variabelen',
    klikOmTeKopieren: 'Klik om te kopiëren',
    klikChipHint: 'Klik op een variabele om hem naar het klembord te kopiëren.',
    variabelGekopieerdPrefix: 'Gekopieerd: ',
    tabOvereenkomstHerinnering: 'Herinnering — Overeenkomst',
    tabProspectHerinnering: 'Herinnering — Prospect',
    herinneringPerIndexUitleg: 'Elke herinnering heeft een eigen onderwerp en introtekst — nooit gedeeld met de andere herinneringen. Het aantal velden volgt het ingestelde maximum ({max}) op de instellingenpagina.',
    herinneringLabel: 'Herinnering {n}',
    labelOnderwerpHerinnering: 'Onderwerp',
    labelIntroHerinneringIndex: 'Introductietekst',
    geenMaximumIngesteld: 'Er is nog geen maximum aantal herinneringen ingesteld. Stel dit eerst in bij Instellingen.',
    bijlagenTitel: 'Vaste bijlage(n) bij deze herinnering',
    bijlagenUitleg: 'Deze bijlage(n) worden bij elke automatische verzending van dit herinneringsniveau meegestuurd. Niet per verzending kiesbaar.',
    bijlageUploaden: 'Bijlage toevoegen',
    bijlageVerwijderen: 'Verwijderen',
    geenBijlagen: 'Nog geen bijlage toegevoegd.',
    bijlageGeupload: 'Bijlage toegevoegd.',
    bijlageVerwijderd: 'Bijlage verwijderd.',
    foutBijlageUpload: 'Fout bij uploaden bijlage: ',
    foutBijlageVerwijderen: 'Fout bij verwijderen bijlage: ',
    foutBijlageType: 'Alleen PDF- of afbeeldingsbestanden (PDF, PNG, JPEG, WEBP) zijn toegestaan als bijlage.',
    foutBijlageGrootte: 'Bijlage is te groot — maximaal 10 MB toegestaan.',
    foutLadenHerinneringen: 'Fout bij laden herinneringsteksten: ',
    opgeslagenHerinneringen: 'Herinneringsteksten opgeslagen.',
    foutOpslaanHerinneringen: 'Fout bij opslaan herinneringsteksten: ',
  },
  welkomstmail: {
    stuurWelkomstmail: 'Welkomstmail versturen',
    checkboxLabel: 'Stuur welkomstmail naar deze client',
    bevestigingTitel: 'Welkomstmail versturen',
    bevestigingTekst: 'Wil je een welkomstmail sturen naar {naam}? De mail wordt verstuurd naar {email}.',
    versturen: 'Versturen',
    annuleren: 'Annuleren',
    succes: 'Welkomstmail verstuurd.',
    fout: 'Fout bij versturen welkomstmail: ',
    foutSessie: 'Sessie verlopen — log opnieuw in.',
  },
  instellingen_urls: {
    urlsTitel: 'App- en portaal-URL\'s',
    urlsSubtitel: 'Deze URL\'s worden gebruikt in welkomstmails en andere communicatie.',
    labelGymUrl: 'Webportaal URL',
    labelAppStoreUrl: 'App Store URL',
    labelPlayStoreUrl: 'Google Play URL',
    placeholderGymUrl: 'https://app.fitensterker.nl',
    placeholderAppStoreUrl: 'https://apps.apple.com/...',
    placeholderPlayStoreUrl: 'https://play.google.com/...',
  },
  broadcastPush: {
    title: 'Broadcast push notificatie',
    subtitle: 'Stuur een pushbericht naar een gefilterde groep cliënten',
    sectionFilters: 'Filters',
    filterLocatie: 'Locatie (optioneel)',
    filterLocatiePlaceholder: 'Alle locaties',
    filterAbonnementstype: 'Abonnementstype (optioneel)',
    filterAbonnementstypePlaceholder: 'Alle abonnementen',
    filterCoach: 'Coach (optioneel)',
    filterCoachPlaceholder: 'Alle coaches',
    sectionBericht: 'Bericht',
    labelTitel: 'Berichttitel',
    labelTitelPlaceholder: 'Bijv. Belangrijke mededeling',
    labelTekst: 'Berichttekst',
    labelTekstPlaceholder: 'Typ hier je bericht…',
    previewSection: 'Ontvangers',
    previewLoading: 'Ontvangers laden…',
    previewOntvangers: '{count} ontvangers geselecteerd',
    previewGeenOntvangers: 'Geen ontvangers gevonden met deze filters',
    geenPushToken: 'geen token — wordt overgeslagen',
    verstuurKnop: 'Verstuur naar {count} ontvangers',
    verstuurKnopDisabled: 'Vul alle velden in en selecteer ontvangers',
    bevestigingTitel: 'Bevestiging',
    bevestigingTekst: 'Wil je dit bericht versturen naar {count} cliënten?',
    bevestigingAnnuleren: 'Annuleren',
    bevestigingVersturen: 'Versturen',
    succesVerstuurd: 'Bericht verstuurd naar {sent} ontvangers',
    succesZonderToken: '({skipped} zonder push token overgeslagen)',
    foutLaden: 'Fout bij laden ontvangers: ',
    foutVersturen: 'Fout bij versturen: ',
    rateLimitBereikt: 'Dagelijkse limiet bereikt: je hebt vandaag al {used} van de {limit} toegestane broadcasts verstuurd. Probeer het morgen opnieuw of laat een admin de limiet aanpassen.',
    foutLocaties: 'Fout bij laden locaties: ',
    foutAbonnementen: 'Fout bij laden abonnementen: ',
    foutCoaches: 'Fout bij laden coaches: ',
  },
  prospect: {
    title: 'Prospect-status',
    statusProspect: 'Prospect',
    statusActive: 'Actief lid',
    badgeProspect: 'Prospect',
    overeenkomstOpstellenKnop: 'Overeenkomst opstellen',
    filterProspects: 'Toon alleen prospects',
    filterAll: 'Toon alle clients',
    typeLabel: 'Type client',
    typeSelectProspect: 'Prospect (potentiële klant)',
    typeSelectActive: 'Actief lid (met abonnement)',
    geenAbonnementVereist: 'Geen abonnement vereist voor prospect',
  },
  trialSession: {
    title: 'Gratis proefsessie',
    markAsTrial: 'Markeer als proefsessie',
    isTrial: 'Proefsessie',
    badgeTrial: 'Proefsessie (gratis)',
    noCreditsCharged: 'Geen credits afgetrokken (proefsessie)',
    trialExplainer: 'Een proefsessie is gratis en telt niet mee voor credits.',
    enrollAsTrial: 'Inschrijven als proefsessie (gratis)',
  },
  agreement: {
    stuurOvereenkomst: 'Nieuwe overeenkomst opstellen',
    modalTitel: 'Overeenkomst versturen',
    modalUitleg: 'Verstuur een digitale overeenkomst naar deze client. De client ontvangt een e-mail en push notificatie met een link om de overeenkomst te bekijken en digitaal te ondertekenen.',
    labelAbonnementstype: 'Abonnementstype voorstellen (optioneel)',
    clientKiestZelf: 'Client kiest zelf',
    abonnementstypeHint: 'Als je een type voorstelt, wordt dit automatisch vooraf geselecteerd. Anders kan de client zelf kiezen.',
    ontvangerInfo: 'Ontvanger',
    geldigheid: 'Link geldig voor 7 dagen',
    annuleren: 'Annuleren',
    versturen: 'Versturen',
    versturenBezig: 'Versturen…',
    verstuurdSuccess: 'Overeenkomst succesvol verstuurd! Client ontvangt een e-mail en push notificatie.',
    verstuurdFout: 'Fout bij versturen: ',
    openstaandTokensTitel: 'Openstaand — wacht op handtekening',
    statusOpenstaand: 'Verstuurd, nog niet ondertekend',
    verstuurdOp: 'Verstuurd op',
    verlooptOp: 'Verloopt op',
    geenOndertekendNogWachten: 'Client heeft de overeenkomst nog niet ondertekend.',
    intrekkenKnop: 'Intrekken',
    intrekkenTitel: 'Overeenkomst intrekken',
    intrekkenBevestig: 'Weet je zeker dat je dit token wilt intrekken? De client kan de link dan niet meer gebruiken om te ondertekenen.',
    intrekkenBevestigKnop: 'Ja, intrekken',
    intrekkenBezig: 'Bezig…',
    ingetrokkenSuccess: 'Token ingetrokken.',
    intrekkenFout: 'Fout bij intrekken: ',
    downloadFout: 'Fout bij laden PDF.',
    stuurOpnieuw: 'Opnieuw sturen',
    stuurOpnieuwSuccess: 'Overeenkomst opnieuw verstuurd!',
    stuurOpnieuwFout: 'Fout bij opnieuw versturen: ',
    kopieerLink: 'Kopieer link',
    linkGekopieerd: 'Link gekopieerd!',
    allTokensTitel: 'Verzonden overeenkomsten',
    statusOpenstaandLabel: 'Openstaand',
    statusOndertekendLabel: 'Ondertekend',
    statusAfgewezenLabel: 'Afgewezen',
    statusIngetrokkenLabel: 'Ingetrokken',
    statusVerlopenLabel: 'Verlopen',
    verlopenOp: 'Verlopen op',
    geldigTm: 'Geldig t/m',
    datumVerzonden: 'Verzonden op',
    afgewezenDoor: 'Afgewezen door',
    redenAfwijzing: 'Reden: ',
    staffelKiezen: 'Staffel kiezen',
    staffelKiezenHint: 'Selecteer de looptijd en prijs voor deze overeenkomst.',
    staffelVerplicht: 'Kies een staffel bij het geselecteerde abonnementstype.',
    customVoorwaarden: 'Aangepaste voorwaarden',
    customVoorwaardenInfo: 'Gebruik afwijkende prijs of credits voor deze specifieke overeenkomst. De looptijd en betaalfrequentie worden overgenomen van de geselecteerde staffel.',
    customNaam: 'Aangepaste naam (optioneel)',
    customPrijsPerMaand: 'Prijs per maand (€)',
    customCredits: 'Credits',
    customPrijsVerplicht: 'Prijs per maand is verplicht bij aangepaste voorwaarden.',
    customCreditsVerplicht: 'Credits zijn verplicht bij aangepaste voorwaarden.',
    customTypeVerplicht: 'Kies een abonnementstype voordat je aangepaste voorwaarden instelt.',
    customStaffelVerplicht: 'Kies een staffel voordat je aangepaste voorwaarden instelt.',
    bonusSectie: 'Bonusabonnementen meesturen',
    bonusGratis: 'Gratis',
    bonusStaffelprijs: 'Staffelprijs',
    extraToevoegen: '+ Extra abonnement toevoegen',
    overzichtTitel: 'Overzicht abonnementen',
  },
  overeenkomst: {
    titel: 'Digitale overeenkomst',
    laden: 'Overeenkomst laden...',
    foutTitel: 'Link ongeldig',
    tokenOngeldig: 'Deze link is ongeldig of verlopen. Neem contact op met je coach voor een nieuwe link.',
    typeNietGevonden: 'Het voorgestelde abonnementstype is niet meer beschikbaar.',
    foutLaden: 'Fout bij laden overeenkomst: ',
    kiesAbonnement: 'Kies je abonnement',
    kiesAbonnementUitleg: 'Selecteer het abonnement dat bij je past. Na je keuze kun je de overeenkomst lezen en ondertekenen.',
    selecteren: 'Selecteren',
    leesOvereenkomst: 'Overeenkomst',
    geenTekst: 'Nog geen overeenkomsttekst beschikbaar. Neem contact op met je coach.',
    plaatsHandtekening: 'Handtekening',
    handtekeningUitleg: 'Teken met je muis of vinger in het veld hieronder.',
    wisHandtekening: 'Wissen',
    geenHandtekening: 'Plaats eerst je handtekening voordat je ondertekent.',
    akkoordLabel: 'Ik heb de overeenkomst gelezen en ga akkoord met de voorwaarden.',
    akkoordVerplicht: 'Vink het akkoordvakje aan voordat je ondertekent.',
    voorwaardenTypeKop: 'Voorwaarden',
    ondertekenen: 'Ondertekenen en afsluiten',
    bezig: 'Bezig met ondertekenen...',
    foutOndertekenen: 'Fout bij ondertekenen: ',
    bedanktTitel: 'Overeenkomst ondertekend!',
    bedanktTekst: 'Je overeenkomst is succesvol ondertekend. Je account is nu actief en je kunt direct beginnen met trainen. Je ontvangt een bevestiging per e-mail.',
    bedanktSluiten: 'Je kunt deze pagina nu sluiten.',
    afwijzenKnop: 'Overeenkomst afwijzen',
    afwijzenTitel: 'Overeenkomst afwijzen',
    afwijzenUitleg: 'Weet je zeker dat je deze overeenkomst wilt afwijzen? Je coach wordt op de hoogte gesteld.',
    afwijzenRedenPlaceholder: 'Reden (optioneel)…',
    afwijzenAnnuleer: 'Annuleren',
    afwijzenBevestig: 'Ja, afwijzen',
    afwijzenBezig: 'Bezig…',
    foutAfwijzen: 'Fout bij afwijzen',
    afgewezenTitel: 'Overeenkomst afgewezen',
    afgewezenTekst: 'Je hebt de overeenkomst afgewezen. Neem contact op met je coach als je vragen hebt.',
    tokenAlGebruikt: 'Deze overeenkomst is al ondertekend.',
    tokenAfgewezenOfIngetrokken: 'Deze link is afgewezen of ingetrokken. Neem contact op met je coach voor een nieuwe link.',
    customVoorwaardenTitel: 'Overeengekomen voorwaarden',
    customPrijsLabel: 'Prijs',
    customCreditsLabel: 'Credits',
    openstaandTokenBannerTitel: 'Let op: er staat al een overeenkomst open voor deze cliënt',
    openstaandTokenBannerRegel: 'Verstuurd op {datum} — {type}',
    openstaandTokenBannerType: 'algemene overeenkomst (cliënt kiest zelf abonnement)',
    openstaandTokenBannerUitleg: 'Als je hieronder een nieuwe overeenkomst verstuurt, vervalt deze automatisch.',
    customLooptijdLabel: 'Looptijd',
    customDagen: 'dagen',
    extraAbonnementenTitel: 'Inbegrepen abonnementen',
    onbekendType: '(onbekend abonnementstype)',
    stepperABSteps: 'Staffel,Betaling,Overzicht,Ondertekenen',
    stepperCDSteps: 'Keuze,Configuratie,Overzicht,Ondertekenen',
    stepVolgende: 'Volgende',
    stepTerug: 'Terug',
    afwijzenRedenVerplicht: 'Geef een reden op voor het afwijzen.',
    scenarioABStaffelTitel: 'Kies je looptijd',
    scenarioABOmschrijving: 'Selecteer de looptijd die het beste bij je past.',
    scenarioCDTitel: 'Kies je abonnement',
    scenarioCDUitleg: 'Selecteer een abonnement per categorie. Je kunt per sessietype maximaal één abonnement kiezen.',
    sectionPt: '1-op-1 Personal Training',
    sectionPtPlus: '1-op-2 Personal Training',
    sectionSmallGroup: 'Small Group Training',
    minimaalEenType: 'Selecteer minimaal één abonnementstype om verder te gaan.',
    bonusGratisLabel: 'Gratis inbegrepen',
    bonusBijDitAbo: 'Bij dit abonnement ontvang je gratis:',
    bonusChipGratis: 'Gratis',
    bonusPerMaand: '/mnd',
    bonusInclusiefLabel: 'Inclusief',
    bonusGratis: 'gratis',
    bonusVoegToe: 'Voeg toe',
    bonussenSectieLabel: 'Optionele bonus- en extra abonnementen',
    bonusLooptijdAfwijking: '{hoofd} mnd hoofdabonnement, bonus geldt {bonus} mnd',
    aanbevolenBadge: 'Aanbevolen',
    vanafPrijs: 'Vanaf',
    configuratieTitel: 'Abonnement configureren',
    configuratieVoortgang: 'Abonnement {idx} van {total}',
    configuratieStaffelTitel: 'Kies je looptijd',
    // Onderdeel 4 (2026-07-28): zelfde correctie als overeenkomstBetaalfreq.kiesTitel —
    // dit is de betaaltermijn-stap (maandelijks/eenmalig), niet de betaalmethode.
    configuratieBetaalTitel: 'In welke termijn wil je betalen?',
    overzichtTitelPagina: 'Overzicht',
    overzichtHoofdAbo: 'Hoofdabonnement',
    overzichtBonussen: 'Inbegrepen bonusabonnementen',
    overzichtTotaal: 'Totaal per maand',
    overzichtGratis: 'Gratis',
    overzichtAboItem: '{months} maanden — {freq}',
    overzichtFreqMaand: 'maandbetaling',
    overzichtFreqPeriode: 'eenmalig voor periode',
    sessieduurKiezen: 'Kies sessieduur',
    sessieduur30: '30 minuten',
    sessieduur60: '60 minuten',
    sessieduurVerplicht: 'Kies een sessieduur om verder te gaan.',
    staffelVerplicht: 'Selecteer een looptijd om verder te gaan.',
    geselecteerd: 'Geselecteerd',
    vanafPerMaand: 'Vanaf {prijs}/mnd',
    creditsPerMaand: '{n} credits/mnd',
    stepperCDStepsCoach: 'Keuze,Configuratie,Overzicht',
    coachModusTitel: 'Overeenkomst opstellen',
    coachModusUitleg: 'Stel de overeenkomst samen voor {naam}. Wat je invult staat vast; wat je openlaat vult de cliënt zelf aan.',
    verstuurNaarClient: 'Verstuur naar cliënt',
    verstuurBezig: 'Bezig met versturen...',
    verstuurGeluktTitel: 'Overeenkomst verstuurd!',
    verstuurGeluktTekst: 'De cliënt heeft een e-mail ontvangen met een link om de overeenkomst aan te vullen en te ondertekenen.',
    foutVersturen: 'Fout bij versturen: ',
    alGekozenDoorCoach: 'Al gekozen door je coach',
    clientNietGevonden: 'Deze cliënt is niet gevonden.',
    clientVerwijderd: 'Dit cliëntprofiel is verwijderd. Er kan geen nieuwe overeenkomst meer voor worden opgesteld.',
    geenToegangCoachModus: 'Je hebt geen toegang tot deze pagina.',
    aangepasteVoorwaardenToggle: 'Aangepaste voorwaarden voor dit abonnement',
    aangepasteNaamLabel: 'Naam',
    aangepastePrijsLabel: 'Prijs per maand (€)',
    aangepasteCreditsLabel: 'Credits',
    standaardNaamHelper: 'Standaard: {naam}',
    standaardPrijsHelper: 'Standaard: {prijs}/mnd',
    standaardCreditsHelper: 'Standaard: {credits} credits/periode',
    uitsluitenKnopTitel: 'Dit type uitsluiten voor deze cliënt',
    uitgeslotenLabel: 'Uitgesloten voor deze cliënt',
    uitgeslotenHerstellen: 'Ongedaan maken',
    uitgeslotenSectieTitel: 'Uitgesloten voor deze cliënt',
    // Onderdeel 1+2 (2026-07-28 vervolgsessie): al-actieve abonnementen —
    // uitgrijzen in de coach-builder (stap 1) en waarschuwen vóór ondertekenen.
    alActiefSinds: 'Al actief sinds {datum}',
    alActiefWaarschuwingTitel: 'Dit heb je al actief',
    alActiefWaarschuwingUitleg: 'Je kunt deze overeenkomst niet ondertekenen zolang dit abonnement al actief bij je staat. Neem contact op met je coach als je denkt dat dit niet klopt.',
    verstuurBevestigTitel: 'Overeenkomst versturen naar cliënt?',
    verstuurBevestigOntvanger: 'Ontvanger',
    verstuurBevestigAbonnementen: 'Gekozen abonnement(en)',
    verstuurBevestigOpenstaand: 'De cliënt vult deze keuzes zelf nog aan',
    verstuurBevestigGeenOpenstaand: 'Alle keuzes zijn al ingevuld — de cliënt hoeft alleen nog te ondertekenen.',
    verstuurBevestigAnnuleren: 'Annuleren',
    verstuurBevestigBevestigen: 'Ja, verstuur',
    customRegelsSectieTitel: 'Aanvullende afspraken',
    customRegelToevoegen: '+ Aangepaste regel toevoegen',
    customRegelVerwijderen: 'Verwijderen',
    customRegelInclBtw: '(incl. btw)',
    customRegelModalTitel: 'Aangepaste regel toevoegen',
    customRegelModalUitleg: 'Deze regel wordt vast onderdeel van de overeenkomst — de cliënt ziet ‘m, maar kan ‘m niet zelf wijzigen of verwijderen.',
    customRegelNaamLabel: 'Naam / omschrijving',
    customRegelNaamPlaceholder: 'Bijv. "Korting eerste maand"',
    customRegelBedragLabel: 'Eenmalig bedrag (€, incl. btw) — optioneel',
    customRegelBedragPlaceholder: 'Bijv. -10,00 voor korting, 25,00 voor extra kosten',
    customRegelBedragHelper: 'Positief = extra kosten op de factuur. Negatief = korting. Bedrag is inclusief btw (9%, zelfde standaardtarief als de rest van de factuur).',
    customRegelCreditsLabel: 'Eenmalige credit-toekenning (aantal) — optioneel',
    customRegelCreditsPlaceholder: 'Bijv. 1',
    customRegelPoolLabel: 'Creditpool',
    customRegelPoolKies: 'Kies een pool...',
    customRegelGeenPools: 'Geen enkele creditpool is beschikbaar — kies eerst een abonnement (of dit type heeft al een actief abonnement bij deze cliënt) voordat je hier credits aan kunt toekennen.',
    customRegelOpslaan: 'Toevoegen',
    customRegelNaamVerplicht: 'Vul een naam/omschrijving in.',
    customRegelMinimaalEen: 'Vul minimaal een bedrag of een credit-toekenning in.',
    customRegelPoolVerplicht: 'Kies een creditpool voor de credit-toekenning.',
    customRegelCreditsPositief: 'Het aantal credits moet groter dan 0 zijn.',
    nawTitel: 'Jouw gegevens',
    nawUitleg: 'Deze gegevens komen in de overeenkomst te staan. Voorgevuld indien al bij ons bekend — pas ze aan als je bent verhuisd.',
    nawLabelNaam: 'Naam',
    nawLabelStraat: 'Straat',
    nawLabelHuisnummer: 'Huisnummer',
    nawLabelPostcode: 'Postcode',
    nawLabelPlaats: 'Woonplaats',
    nawOngeldig: 'Vul een geldig adres in (straat, huisnummer, postcode en woonplaats) voordat je ondertekent.',
  },
  overeenkomstBetaalfreq: {
    // Onderdeel 4 (2026-07-28): dit scherm gaat over de betaaltermijn
    // (maandelijks vs. eenmalig voor de hele periode), niet over de
    // betaalmethode — die vraag ("Hoe wil je betalen?", manual/iDEAL/SEPA)
    // zit in overeenkomstBetaalmethode.titel en is bewust ongewijzigd.
    kiesTitel: 'In welke termijn wil je betalen?',
    maandelijks: 'Maandelijks',
    maandelijksLabel: 'per maand',
    eenmalig: 'Eenmalig',
    eenmaligMetKorting: 'Eenmalig (met korting)',
    kortingLabel: 'korting',
    kortingBesparing: 'Besparing',
    eenmaligKortingToelichting: 'Inclusief {pct}% korting voor eenmalige betaling',
    verplicht: 'Kies een betaalfrequentie om verder te gaan.',
  },
  overeenkomstBetaalmethode: {
    titel: 'Hoe wil je betalen?',
    manual: 'Handmatig (betaling via factuur)',
    ideal: 'iDEAL',
    sepa: 'SEPA-incasso (automatische afschrijving)',
    ibanLabel: 'IBAN',
    ibanPlaceholder: 'NL00 BANK 0123 4567 89',
    ibanUitleg: 'Wordt uitsluitend gebruikt om een SEPA-machtiging aan te maken. We bewaren zelf alleen de laatste 4 cijfers.',
    ibanOngeldig: 'Vul een geldig IBAN-nummer in.',
    // F4-10 SEPA-machtigingsaddendum
    sepaMachtigingAkkoordLabel: 'Ik ga akkoord met bovenstaande doorlopende SEPA-machtiging.',
    sepaMachtigingAkkoordVerplicht: 'Je moet akkoord gaan met de SEPA-machtiging om verder te gaan.',
  },
  staffelKaart: {
    kortingLabel: '{pct}% korting bij eenmalige betaling',
  },
  mijnAbonnement: {
    title: 'Mijn abonnement',
    actiefAbonnement: 'Actieve abonnementen',
    geenAbonnement: 'Geen actief abonnement gevonden.',
    naam: 'Naam abonnement',
    looptijd: 'Looptijd',
    resteCredits: 'Resterende credits',
    ptCredits: 'PT-credits',
    ptPlusCredits: 'PT-plus credits',
    smallGroupCredits: 'Small Group credits',
    status: 'Status',
    actief: 'Actief',
    verlopen: 'Verlopen',
    doorlopend: 'doorlopend',
    aangepast: 'Aangepast',
    onbekend: 'Onbekend',
    overeenkomsten: 'Overeenkomsten',
    geenOvereenkomsten: 'Nog geen overeenkomsten.',
    geenOndertekend: 'Nog geen ondertekende overeenkomsten.',
    ondertekendOp: 'Ondertekend op',
    download: 'Download',
    downloadFout: 'Fout bij downloaden PDF.',
    afsluitenTitel: 'Abonnement afsluiten',
    afsluitenInfo: 'Je kunt een nieuw abonnement afsluiten door de overeenkomst te ondertekenen.',
    afsluitenBtn: 'Sluit abonnement af',
    contactCoach: 'Neem contact op met je coach om een abonnement af te sluiten.',
    foutLaden: 'Fout bij laden: ',
    statusNietOndertekend: 'Nog niet ondertekend',
    verstuurdOp: 'Verstuurd op',
    geldigTm: 'Geldig t/m',
    ondertekenenBtn: 'Onderteken nu',
    afwijzenKnop: 'Afwijzen',
    afwijzenTitel: 'Overeenkomst afwijzen',
    afwijzenUitleg: 'Weet je zeker dat je deze overeenkomst wilt afwijzen? Je coach wordt hiervan op de hoogte gesteld.',
    afwijzenRedenLabel: 'Reden (optioneel)',
    afwijzenRedenPlaceholder: 'Licht toe waarom je de overeenkomst afwijst…',
    afwijzenAnnuleer: 'Annuleren',
    afwijzenBevestig: 'Ja, afwijzen',
    afwijzenBezig: 'Bezig…',
    afwijzenFout: 'Fout bij afwijzen: ',
    statusAfgewezen: 'Afgewezen',
    statusIngetrokken: 'Ingetrokken door coach',
    statusVerlopen: 'Verlopen',
    opzeggenKnop: 'Abonnement opzeggen',
    opzeggenBevestiging: 'Weet je zeker dat je je abonnement wilt opzeggen? Je hebt nog toegang tot {datum}.',
    opzeggenFout: 'Fout bij opzeggen: ',
    opzeggenPushTitel: 'Abonnement opgezegd',
    opzeggenPushBody: 'Je abonnement is opgezegd. Je hebt nog toegang tot {datum}.',
    opgezegd: 'Opgezegd — loopt af op {datum}',
    heractiverenKnop: 'Heractiveer abonnement',
    heractiverenTitel: 'Abonnement heractiveren',
    heractiverenUitleg: 'Je abonnement wordt voortgezet en weer automatisch verlengd en geïncasseerd zoals voorheen.',
    heractiverenAkkoord: 'Ik ga akkoord dat de overeenkomst wordt voortgezet',
    heractiverenBevestigKnop: 'Heractiveer',
    heractiverenFout: 'Fout bij heractiveren: ',
    heractiverenNietMeerMogelijk: 'Heractiveren is niet meer mogelijk. Sluit een nieuw abonnement af of neem contact op met je coach.',
  },
  ptAanvragen: {
    titel: 'PT-aanvragen',
    geenAanvragen: 'Geen openstaande aanvragen.',
    laden: 'Aanvragen laden…',
    foutLaden: 'Kon aanvragen niet laden: ',
    statusPending: 'In behandeling',
    statusRescheduled: 'Alternatief voorgesteld',
    clientLabel: 'Cliënt',
    datumLabel: 'Datum',
    duurLabel: 'Duur',
    minutenSuffix: '{{count}} minuten',
    locatieLabel: 'Locatie',
    notitieLabel: 'Notitie',
    rescheduledNota: 'Notitie coach',
    accepteerKnop: 'Accepteren',
    afwijzenKnop: 'Afwijzen',
    alternatiefKnop: 'Alternatief voorstellen',
    bevestigenKnop: 'Bevestigen',
    geaccepteerd: 'Afspraak aangemaakt en cliënt geïnformeerd.',
    afgewezen: 'Aanvraag afgewezen en cliënt geïnformeerd.',
    alternatiefVerstuurd: 'Alternatief voorstel verstuurd naar cliënt.',
    foutBijwerken: 'Kon aanvraag niet bijwerken: ',
    alternatiefTitel: 'Alternatief voorstellen',
    nieuweDatumLabel: 'Nieuwe datum *',
    nieuwTijdLabel: 'Nieuw tijdstip *',
    notitiePlaceholder: 'Toelichting voor de cliënt…',
    verstuurKnop: 'Voorstel versturen',
    datumVerplicht: 'Vul een datum in.',
    tijdVerplicht: 'Vul een tijdstip in.',
    conflicten: 'Roosterconflicten gevonden. Toch accepteren?',
    conflictenTitel: 'Roosterconflict',
    tochAccepteren: 'Toch accepteren',
    annuleren: 'Annuleren',
    pushAccepteerdTitel: 'Je PT-aanvraag is bevestigd',
    pushAccepteerdBody: 'Je PT-aanvraag op {datum} is bevestigd.',
    pushAfgewezenTitel: 'PT-aanvraag afgewezen',
    pushAfgewezenBody: 'Je PT-aanvraag op {datum} is helaas afgewezen.',
    pushAlternatiefTitel: 'Alternatief voorstel ontvangen',
    pushAlternatiefBody: 'Je coach heeft een alternatief tijdstip voorgesteld voor je PT-afspraak. Bekijk en reageer in de app.',
  },
  blocking: {
    fallbackNaam: 'klant',
    fallbackClientNaam: 'een client',
    fallbackLesNaam: 'les',
    clientBlockedPushTitel: 'Account geblokkeerd',
    clientBlockedPushBody: 'Je account is geblokkeerd wegens een openstaande incasso. Neem contact op met je coach.',
    clientBlockedEmailSubject: 'Account geblokkeerd — Fit en Sterker',
    clientBlockedEmailHeading: 'Account geblokkeerd',
    clientBlockedEmailGreeting: 'Beste {naam},',
    clientBlockedEmailBody1: 'Je account bij Fit en Sterker is geblokkeerd wegens een openstaande incasso.',
    clientBlockedEmailBody2: 'Je hebt momenteel geen toegang tot groepslessen en PT-afspraken.',
    clientBlockedEmailBody3: 'Neem contact op met je coach om dit op te lossen.',
    emailSignatureVriendelijk: 'Met vriendelijke groet,<br/>Fit en Sterker',
    coachBlockedPushTitel: 'Client geblokkeerd',
    coachBlockedPushBody: 'Het account van {naam} is geblokkeerd wegens incasso.',
    lessonRestoredPushTitel: 'Weer ingeschreven',
    lessonRestoredPushBody: 'Je bent weer ingeschreven voor {les} op {datum}.',
    lessonRemovedPushTitel: 'Les vol',
    lessonRemovedPushBody: 'Je blokkering is opgeheven, maar {les} op {datum} is helaas vol. Schrijf je opnieuw in als er plek vrijkomt.',
    clientUnblockedPushTitel: 'Account gedeblokkeerd',
    clientUnblockedPushBody: 'Je account is gedeblokkeerd. Je hebt weer volledige toegang.',
    clientUnblockedEmailSubject: 'Account gedeblokkeerd — Fit en Sterker',
    clientUnblockedEmailHeading: 'Account gedeblokkeerd',
    clientUnblockedEmailBody1: 'Je account bij Fit en Sterker is gedeblokkeerd. Je hebt weer volledige toegang tot groepslessen en PT-afspraken.',
    clientUnblockedEmailRestoredNote: 'Je bent automatisch weer ingeschreven voor {count} les(sen).',
    clientUnblockedEmailRemovedNote: 'Voor {count} les(sen) was helaas geen plek meer. Schrijf je opnieuw in via de app.',
    emailSignatureSportief: 'Met sportieve groet,<br/>Fit en Sterker',
    coachUnblockedPushTitel: 'Client gedeblokkeerd',
    coachUnblockedPushBody: 'Het account van {naam} is gedeblokkeerd.',
  },
  acties: {
    titel: 'Openstaande acties',
    afgewezenOvereenkomsten: 'Afgewezen overeenkomsten',
    verlopenOvereenkomsten: 'Verlopen overeenkomsten',
    prospectenZonderActie: 'Prospects zonder actie',
    openstaandeIncasso: 'Openstaande incasso',
    geenActies: 'Geen openstaande acties.',
    geenItems: 'Geen items.',
    stuurNieuwToken: 'Stuur nieuw token',
    stuurOpnieuw: 'Opnieuw versturen',
    actieUitvoeren: 'Actie uitvoeren',
    afhandelen: 'Afhandelen',
    foutAfhandelen: 'Fout bij afhandelen: ',
    afgewezenDoor: 'Afgewezen door: ',
    redenAfwijzing: 'Reden: ',
    verlopenOp: 'Verlopen op: ',
    aangemeldOp: 'Aangemeld op: ',
    openstaandBedrag: 'Openstaand bedrag: ',
    clientBekijken: 'Bekijk client →',
    foutLaden: 'Fout bij laden acties: ',
    laden: 'Acties laden…',
    bevestigVersturenTitel: 'Overeenkomst versturen?',
    bevestigVersturenNaam: 'Naam: ',
    bevestigVersturenTemplate: 'Overeenkomst: ',
    bevestigVersturenEmail: 'E-mailadres: ',
    algemeneOvereenkomst: 'Algemene overeenkomst (cliënt kiest zelf abonnement)',
    emailOntbreektOfOngeldig: 'Dit e-mailadres ontbreekt of is ongeldig. Vul eerst een geldig e-mailadres aan in het profiel voordat de overeenkomst verstuurd kan worden.',
    annuleren: 'Annuleren',
    ofZelfSamenstellen: 'Of stel zelf een overeenkomst samen →',
    overeenkomstVerstuurdOp: 'Overeenkomst verstuurd op ',
    wachtOpOndertekening: ' — wacht op ondertekening',
  },
  cronDashboard: {
    titel: 'Cron-dashboard',
    subtitel: 'Overzicht van geautomatiseerde jobs: planning, uitvoeringshistorie en preview van de volgende run.',
    laden: 'Dashboard laden…',
    tabPlanning: 'Planning',
    tabHistorie: 'Historie',
    tabPreview: 'Preview',
    tabRunstatus: 'Runstatus',

    // Runstatus (cron_run_log — de werkelijke run-uitkomst)
    runstatusTitel: 'Werkelijke run-status per job',
    runstatusUitleg: 'De échte uitkomst van elke cron-run uit cron_run_log. In tegenstelling tot de uitvoeringshistorie (cron.job_run_details), die altijd "succeeded" toont zodra het HTTP-verzoek is ingepland — ook als de Edge Function daarna crashte.',
    runstatusRecenteTitel: 'Recente runs',
    runstatusVoetnoot: 'Groen = laatste run geslaagd. Oranje = geslaagd maar met overgeslagen/gefaalde items (of gedetecteerde problemen bij de health-check). Rood = run gefaald.',
    geenRunstatus: 'Nog geen runs gelogd in cron_run_log.',
    colLaatsteRun: 'Laatste run',
    colSamenvatting: 'Samenvatting',
    colFouten: 'Fouten',
    geenFouten: 'Geen',
    statusSuccess: 'Geslaagd',
    statusPartial: 'Aandacht',
    statusFailed: 'Gefaald',
    nooitGedraaid: 'Nog niet gedraaid',
    jobHealthCheck: 'Cron-signaleringscheck',
    jobSync: 'Agenda-synchronisatie',

    // Planning
    planningTitel: 'Geplande jobs',
    planningVoetnoot: 'Alle tijden zijn in UTC. De lokale tijd kan afwijken afhankelijk van de tijdzone.',
    colNaam: 'Job naam',
    colOmschrijving: 'Omschrijving',
    colSchema: 'Schema',
    colVolgende: 'Volgende uitvoering',
    colActief: 'Status',
    actief: 'Actief',
    inactief: 'Inactief',
    geenJobs: 'Geen cron jobs gevonden.',
    dagelijksOm: 'Dagelijks om',

    // Job labels
    jobFactuur: 'Factuurherinneringen',
    jobProspect: 'Prospect herinneringen',
    jobAkkoord: 'Overeenkomst herinneringen',
    jobFactuurDesc: 'Verstuurt automatisch betalingsherinneringen (14 dgn na vervaldatum) en aanmaningen (14 dgn na herinnering) voor openstaande facturen.',
    jobProspectDesc: 'Stuurt push-herinneringen naar prospects die een gratis proefsessie hebben gehad maar nog geen lid zijn geworden.',
    jobAkkoordDesc: 'Stuurt e-mail herinneringen naar clients met een openstaand, niet-ondertekend overeenkomsttoken.',
    jobAbonnement: 'Abonnementsbeheer',
    jobAbonnementDesc: 'Dagelijkse verwerking: deactiveert opgezegde abonnementen, boekt credits bij, verlengt naar rolling (Wet van Dam) en maakt maandelijkse facturen aan.',
    jobVerloopHerinneringen: 'Abonnementsverloopherinneringen',
    jobVerloopHerinneringenDesc: 'Stuurt push- en e-mailherinneringen naar clients bij naderende abonnementsverlenging, op de verlengingsdag zelf en bij een naderende opzegging.',
    jobVerlopenUitnodigingen: 'Verlopen uitnodigingen opruimen',
    jobVerlopenUitnodigingenDesc: 'Verwijdert verlopen pending_confirmation les-uitnodigingen en stuurt een pushbericht naar de betreffende client.',

    // Historie
    historieTitelUitvoering: 'Uitvoeringshistorie (cron runs)',
    historieMisleidendNote: 'Let op: deze tabel komt uit cron.job_run_details en toont "succeeded" zodra het HTTP-verzoek is ingepland — óók als de Edge Function daarna crashte. Voor de werkelijke run-uitkomst: zie de tab Runstatus.',
    historieTitelBerichten: 'Verzonden berichten',
    filterJob: 'Filter op job:',
    alleJobs: 'Alle jobs',
    geenUitvoeringsdata: 'Geen uitvoeringsdata beschikbaar. Dit vereist pg_cron v1.4 of hoger.',
    geenBerichten: 'Nog geen berichten verzonden.',
    colStarttijd: 'Starttijd',
    colJob: 'Job',
    colStatus: 'Status',
    colDuur: 'Duur',
    colResultaat: 'Resultaat',
    colDatum: 'Datum',
    colClient: 'Cliënt',
    colType: 'Type',
    colDetails: 'Details',

    // Preview
    previewUitleg: 'Dry run: toont wie bij de volgende uitvoering een bericht zou ontvangen, zonder daadwerkelijk te versturen.',
    previewVernieuwen: 'Preview vernieuwen',
    previewLaden: 'Preview laden…',
    volgendeUitvoering: 'Volgende uitvoering',
    geenVerzendingen: 'Geen berichten bij de volgende uitvoering.',
    berichtenBijVolgendeRun: 'berichten bij de volgende uitvoering',
    previewRenewalsGeenActies: 'Geen acties bij de volgende uitvoering.',
    previewRenewalsCancellations: 'Abonnementen te deactiveren',
    previewRenewalsCredits: 'Credits bij te boeken',
    previewRenewalsProlongations: 'Abonnementen te verlengen naar rolling',
    previewRenewalsInvoices: 'Facturen aan te maken',
    previewMembershipGeenHerinneringen: 'Geen herinneringen bij de volgende uitvoering.',
    previewMembershipProlongReminders: 'Verlengingsherinneringen (kandidaten)',
    previewMembershipCancReminders: 'Opzeggingsherinneringen (kandidaten)',
    colFactuurnummer: 'Factuurnummer',
    colBetaaldatum: 'Betaaldatum',
    colDagenVervallen: 'Dagen vervallen',
    colBedrag: 'Bedrag',
    colProefsessie: 'Proefsessie',
    colAantalHerinneringen: 'Herinneringen verstuurd',
    colLaatsteHerinnering: 'Laatste herinnering',
    colInterval: 'Interval',
    colMax: 'Max',
    colVerlooptOp: 'Verloopt op',
    dagAfkorting: 'dgn',
    dagen: 'dagen',

    // Berichttypen
    typeHerinnering: 'Betalingsherinnering',
    typeAanmaning: 'Aanmaning',
    typeProspect: 'Prospect herinnering',
    typeAkkoord: 'Overeenkomst herinnering',

    // Fouten
    foutLaden: 'Fout bij laden dashboard: ',
    foutPreview: 'Fout bij laden preview: ',
    foutTrigger: 'Fout bij uitvoeren job: ',

    // Handmatige trigger — knoppen
    btnTestDraaien: 'Test draaien',
    btnLiveDraaien: 'Live draaien',
    bezig: 'Bezig…',

    // Handmatige trigger — testmodus
    testEmailLabel: 'Testadres (e-mail)',
    testEmailPlaceholder: 'jouw@emailadres.nl',
    testResultaatTitel: 'Testrun geslaagd',
    testResultaatInvoice: 'herinneringen/aanmaningen als testmail naar testadres verstuurd.',
    testResultaatProspect: 'prospect herinneringen als testpush naar testadres verstuurd.',
    testResultaatAgreement: 'overeenkomst herinneringen als testmail naar testadres verstuurd.',
    testGeenEligible: 'Geen cliënten kwamen in aanmerking bij deze run.',

    // Handmatige trigger — live bevestiging
    liveModalTitel: 'Live berichten versturen',
    liveModalWaarschuwing: 'Je staat op het punt ECHTE berichten te versturen. Cliënten die al eerder een bericht ontvingen, worden overgeslagen (idempotentie gewaarborgd).',
    liveModalAantalPrefix: 'Op dit moment komen',
    liveModalAantalSuffix: 'cliënt(en) in aanmerking voor een bericht.',
    liveModalGeenClients: 'Op dit moment zijn er geen cliënten die een bericht zouden ontvangen. Toch doorgaan?',
    liveModalTypeerLabel: 'Typ VERSTUUR om te bevestigen:',
    liveModalTypeerPlaceholder: 'VERSTUUR',
    liveModalBevestigKnop: 'Ja, verstuur nu echte berichten',
    liveModalAnnuleren: 'Annuleren',
    liveResultaatTitel: 'Live run geslaagd',
    liveResultaatInvoice: 'herinneringen/aanmaningen verstuurd naar echte cliënten.',
    liveResultaatProspect: 'prospect herinneringen verstuurd naar echte cliënten.',
    liveResultaatAgreement: 'overeenkomst herinneringen verstuurd naar echte cliënten.',

    // Idempotentie
    previewLadenVoorLive: 'Actueel aantal ophalen…',
  },
  afspraken: {
    title: 'PT-afspraken',
    nieuweKnop: '+ Nieuwe afspraak aanvragen',
    nieuweTitel: 'PT-afspraak aanvragen',
    coach: 'Coach',
    locatie: 'Locatie',
    datum: 'Datum',
    tijd: 'Tijd',
    duur: 'Duur (min)',
    credits: 'Credits',
    notitie: 'Notitie',
    notitiePlaceholder: 'Eventuele opmerkingen…',
    selecteerCoach: 'Selecteer coach…',
    selecteerLocatie: 'Selecteer locatie…',
    annuleren: 'Annuleren',
    indienen: 'Aanvraag indienen',
    bezig: 'Bezig…',
    coachVerplicht: 'Selecteer een coach.',
    locatieVerplicht: 'Selecteer een locatie.',
    duurVerplicht: 'Voer een geldige duur in (min. 15 min).',
    creditsVerplicht: 'Voer een geldig aantal credits in.',
    ingediend: 'Aanvraag succesvol ingediend.',
    foutOpslaan: 'Fout bij indienen aanvraag: ',
    foutLaden: 'Fout bij laden afspraken: ',
    foutReageren: 'Fout bij reageren: ',
    geenAanvragen: 'Je hebt nog geen PT-afspraken aangevraagd.',
    geenAanvragenSub: 'Klik op "+ Nieuwe afspraak aanvragen" om je eerste PT-sessie te boeken.',
    colDatum: 'Datum & tijd',
    colCoach: 'Coach',
    colLocatie: 'Locatie',
    colDuur: 'Duur',
    colCredits: 'Credits',
    colStatus: 'Status',
    statusPending: 'In behandeling',
    statusAccepted: 'Geaccepteerd',
    statusDeclined: 'Afgewezen',
    statusRescheduled: 'Nieuw voorstel',
    voorstelCoach: 'Alternatief voorstel van de coach:',
    origineelAangevraagd: 'Oorspronkelijk aangevraagd',
    accepteren: 'Accepteren',
    afwijzen: 'Afwijzen',
    geaccepteerd: 'Voorstel geaccepteerd.',
    afgewezen: 'Voorstel afgewezen.',
  },
  gebruikersBeheer: {
    title: 'Gebruikersbeheer',
    zoekPlaceholder: 'Zoeken op naam of e-mail…',
    filterAll: 'Alle',
    filterClient: 'Cliënten',
    filterCoach: 'Coaches',
    filterProspect: 'Prospects',
    colNaam: 'Naam',
    colEmail: 'E-mail',
    colRol: 'Rol',
    colStatus: 'Status',
    colCoach: 'Primaire coach',
    colActies: 'Acties',
    bewerken: 'Bewerken',
    bewerkTitel: 'Gebruiker bewerken',
    labelNaam: 'Naam',
    labelEmail: 'E-mailadres',
    labelRol: 'Rol',
    labelCoach: 'Primaire coach toewijzen',
    labelStatus: 'Client status',
    selecteerRol: 'Selecteer rol…',
    selecteerCoach: 'Selecteer coach…',
    geenCoach: 'Geen coach',
    opslaan: 'Opslaan',
    annuleren: 'Annuleren',
    bezig: 'Opslaan…',
    opslaanSucces: 'Gebruiker succesvol bijgewerkt.',
    opslaanFout: 'Fout bij opslaan: ',
    foutLaden: 'Fout bij laden gebruikers: ',
    geenResultaat: 'Geen gebruikers gevonden.',
    nieuweGebruiker: '+ Nieuwe gebruiker',
    aanmakenTitel: 'Nieuwe gebruiker aanmaken',
    labelWachtwoord: 'Wachtwoord',
    wachtwoordTonenTitel: 'Wachtwoord voor nieuwe gebruiker',
    wachtwoordTonenUitleg: 'Dit wachtwoord is automatisch gegenereerd voor {naam} en wordt maar één keer getoond — noteer het of stuur het door.',
    wachtwoordTonenNietGemaild: 'Er is geen e-mail verstuurd — geef dit wachtwoord zelf door aan de gebruiker.',
    wachtwoordTonenSluiten: 'Ik heb het genoteerd, sluiten',
    aanmakenSucces: 'Gebruiker succesvol aangemaakt.',
    aanmakenFout: 'Fout bij aanmaken cliënt: ',
    geenSessie: 'Sessie verlopen — log opnieuw in.',
    validatieNaam: 'Naam is verplicht.',
    validatieEmail: 'E-mailadres is verplicht.',
    validatieRol: 'Rol is verplicht.',
    validatieCoach: 'Kies een coach — zonder coach is de gebruiker niet zichtbaar in de portal.',
    rolSuperadmin: 'Superadmin',
    rolAdminCoach: 'Admin Coach',
    rolCoach: 'Coach',
    rolClient: 'Cliënt',
    statusVerwijderd: 'Verwijderd',
    verwijderen: 'Account verwijderen',
    verwijderTitel: 'Coach-account verwijderen',
    verwijderTekst: 'Weet je zeker dat je het account van {naam} wilt verwijderen? De persoonsgegevens (naam, e-mailadres, telefoon, adres) worden gewist en inloggen wordt geblokkeerd. Gekoppelde lessen, afspraken, overeenkomsten en administratie blijven bestaan en tonen voortaan "Verwijderde coach" — dat is wettelijk en administratief noodzakelijk en kan niet ongedaan worden gemaakt.',
    verwijderBevestig: 'Ja, account verwijderen',
    verwijderSucces: 'Account verwijderd: de persoonsgegevens zijn gewist en inloggen is geblokkeerd.',
    verwijderLoginNietGeblokkeerd: 'De persoonsgegevens zijn gewist, maar het inloggen kon niet worden geblokkeerd. Meld dit bij de beheerder.',
    verwijderFout: 'Fout bij verwijderen: ',
    statusActive: 'Actief',
    statusProspect: 'Prospect',
    statusInactive: 'Inactief',
  },
  betalingBevestiging: {
    titel: 'Betaling',
    laden: 'Even geduld, we controleren de status van je betaling...',
    paid: 'Bedankt! Je betaling is verwerkt.',
    pending: 'Bedankt, we verwerken je betaling. Dit kan enkele minuten duren.',
    failed: 'De betaling is niet gelukt of geannuleerd. Neem contact op met je coach als je vragen hebt.',
    notFound: 'Deze factuur kon niet gevonden worden.',
    terugNaarApp: 'Je kunt dit venster nu sluiten.',
  },
  accountVerwijderen: {
    titel: 'Account en gegevens verwijderen',
    intro: 'Wil je je account bij Fit En Sterker en de daaraan gekoppelde persoonsgegevens laten verwijderen? Hieronder lees je hoe dat werkt, wat er precies gebeurt en welke gegevens wij wettelijk verplicht moeten bewaren.',

    metAppTitel: 'Je hebt nog toegang tot de app',
    metAppIntro: 'Je kunt je account dan zelf verwijderen vanuit de app. Dit gaat direct in.',
    metAppStap1: 'Open de Fit En Sterker-app en log in.',
    metAppStap2: 'Ga naar het tabblad Instellingen en scroll naar het onderdeel "Account verwijderen".',
    metAppStap3: 'Tik op de knop "Account verwijderen".',
    metAppStap4: 'Typ ter bevestiging je eigen e-mailadres in het venster dat verschijnt en tik op "Verwijderen". Je account wordt direct verwijderd en je wordt uitgelogd.',
    metAppLet: 'Let op: staat er nog een onbetaalde factuur open, dan kan het account nog niet worden verwijderd. Neem in dat geval eerst contact op met je coach.',

    zonderAppTitel: 'Je hebt geen toegang (meer) tot de app',
    zonderAppIntro: 'Kun je niet meer inloggen of heb je de app niet meer? Stuur dan een verzoek per e-mail naar:',
    zonderAppVermeld: 'Vermeld in je e-mail in elk geval:',
    zonderAppVermeld1: 'je volledige naam;',
    zonderAppVermeld2: 'het e-mailadres waarmee je account is aangemaakt;',
    zonderAppVermeld3: 'de duidelijke vermelding dat je je account en persoonsgegevens wilt laten verwijderen.',
    zonderAppTermijn: 'Wij verwerken je verzoek binnen 30 dagen en bevestigen de verwijdering per e-mail. We kunnen je vragen je identiteit te bevestigen voordat we het verzoek uitvoeren.',

    gevolgenTitel: 'Wat gebeurt er bij verwijdering?',
    gevolg1: 'Je persoonsgegevens worden verwijderd of geanonimiseerd: naam, e-mailadres, telefoonnummer en adresgegevens worden gewist of overschreven.',
    gevolg2: 'Je toegang tot de app en de webportal wordt direct geblokkeerd; inloggen is daarna niet meer mogelijk.',
    gevolg3: 'Lopende abonnementen worden opgezegd en resterende credits komen te vervallen.',
    gevolg4: 'De verwijdering is definitief en kan niet ongedaan worden gemaakt. Wil je later opnieuw gebruikmaken van onze diensten, dan maak je een nieuw account aan.',

    bewaarTitel: 'Wat blijft wettelijk bewaard?',
    bewaarUitleg: 'Facturen en de bijbehorende financiële administratie moeten wij op grond van de fiscale bewaarplicht 7 jaar bewaren. Deze gegevens kunnen wij daarom niet op verzoek verwijderen.',
    bewaarScheiding: 'Deze financiële gegevens worden na verwijdering niet meer gekoppeld aan je overige persoonsgegevens: die zijn immers gewist of geanonimiseerd. Ze worden uitsluitend nog gebruikt voor de wettelijke administratie en niet voor andere doeleinden.',

    vragen: 'Heb je vragen over de verwerking van je persoonsgegevens of over dit verzoek? Neem dan contact op via bovenstaand e-mailadres.',
  },
  opzeggingen: {
    title: 'Opzeggingen',
    aantalGevonden: 'opzeggingen gevonden',
    foutLaden: 'Fout bij laden: ',
    geenOpzeggingen: 'Nog geen opzeggingen.',
    onbekend: 'Onbekend',
    geenReden: 'Geen reden opgegeven',
    colClient: 'Cliënt',
    colType: 'Abonnement',
    colOpzegdatum: 'Opzegdatum',
    colReden: 'Opzegreden',
    colEinddatum: 'Einddatum looptijd',
    colStatus: 'Status',
    statusNogLopend: 'Nog lopend tot {datum}',
    statusHeractiveerd: 'Heractiveerd op {datum}',
    statusDefinitiefVerlopen: 'Definitief verlopen',
  },
};

export const t = (key, vars) => {
  const str = key.split('.').reduce((o, k) => o?.[k], nl) ?? key;
  if (!vars || typeof str !== 'string') return str;
  return str.replace(/\{(\w+)\}/g, (_, k) => (vars[k] !== undefined ? vars[k] : `{${k}}`));
};
export default nl;
